import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date custom scalar type */
  Date: { input: string; output: string; }
  /** Scalar with date and time information */
  DateTime: { input: string; output: string; }
  /** Scalar representing a JSON object */
  Json: { input: string; output: string; }
  /** Scalar representing a UUID */
  Uuid: { input: string; output: string; }
};

export type AccountType =
  | 'ADMIN'
  | 'CUSTOMER'
  | 'VENDOR_BANK'
  | 'VENDOR_LAWYER';

/** Input type for assignNifOrderVendor mutation */
export type AssignNifOrderVendorInput = {
  nifOrderId: Scalars['Uuid']['input'];
  poaTemplateFile?: InputMaybe<FileUploadInput>;
  vendorId: Scalars['Uuid']['input'];
};

/** Payload type for assignNifOrderVendor mutation */
export type AssignNifOrderVendorPayload = {
  __typename?: 'AssignNifOrderVendorPayload';
  nifOrder: NifOrder;
};

/** Input type for cancelFiscalRepCancellationRequest mutation */
export type CancelFiscalRepCancellationRequestInput = {
  id: Scalars['Uuid']['input'];
};

/** Payload type for cancelFiscalRepCancellationRequest mutation */
export type CancelFiscalRepCancellationRequestPayload = {
  __typename?: 'CancelFiscalRepCancellationRequestPayload';
  fiscalRepCancellationRequest: FiscalRepCancellationRequest;
};

/** Input type for cancelFiscalRepSubscription mutation */
export type CancelFiscalRepSubscriptionInput = {
  cancellationRequestId: Scalars['Uuid']['input'];
  id: Scalars['Uuid']['input'];
};

/** Payload type for cancelFiscalRepSubscription mutation */
export type CancelFiscalRepSubscriptionPayload = {
  __typename?: 'CancelFiscalRepSubscriptionPayload';
  fiscalRepSubscription: FiscalRepSubscription;
};

/** Input type for checkEsignatureContractStatus mutation */
export type CheckEsignatureContractStatusInput = {
  contractId: Scalars['String']['input'];
};

/** Payload type for checkEsignatureContractStatus mutation */
export type CheckEsignatureContractStatusPayload = {
  __typename?: 'CheckEsignatureContractStatusPayload';
  didUpdate: Scalars['Boolean']['output'];
};

/** Input type for checkFiscalRepPaymentStatus mutation */
export type CheckFiscalRepPaymentStatusInput = {
  checkoutSessionId: Scalars['String']['input'];
};

/** Payload type for checkFiscalRepPaymentStatus mutation */
export type CheckFiscalRepPaymentStatusPayload = {
  __typename?: 'CheckFiscalRepPaymentStatusPayload';
  fiscalRepSubscription: FiscalRepSubscription;
};

/** Input type for checkOrderVoucherPaymentStatus mutation */
export type CheckOrderVoucherPaymentStatusInput = {
  checkoutSessionId: Scalars['String']['input'];
};

/** Payload type for checkOrderVoucherPaymentStatus mutation */
export type CheckOrderVoucherPaymentStatusPayload = {
  __typename?: 'CheckOrderVoucherPaymentStatusPayload';
  user: User;
};

/** Input type for commentOnNifOrder mutation */
export type CommentOnNifOrderInput = {
  comment: Scalars['String']['input'];
  isVendor?: InputMaybe<Scalars['Boolean']['input']>;
  nifOrderId: Scalars['Uuid']['input'];
};

/** Payload type for commentOnNifOrder mutation */
export type CommentOnNifOrderPayload = {
  __typename?: 'CommentOnNifOrderPayload';
  nifOrder: NifOrder;
  nifOrderComment: NifOrderComment;
};

/** Payload type for createBullBoardAuthCode mutation */
export type CreateBullBoardAuthCodePayload = {
  __typename?: 'CreateBullBoardAuthCodePayload';
  code: Scalars['String']['output'];
};

/** Input type for createFiscalPasswordRequest mutation */
export type CreateFiscalPasswordRequestInput = {
  data: FiscalPasswordRequestCreateData;
};

/** Payload type for createFiscalPasswordRequest mutation */
export type CreateFiscalPasswordRequestPayload = {
  __typename?: 'CreateFiscalPasswordRequestPayload';
  fiscalPasswordRequest: FiscalPasswordRequest;
};

/** Input type for createFiscalRepCancellationRequest mutation */
export type CreateFiscalRepCancellationRequestInput = {
  data: FiscalRepCancellationRequestCreateData;
};

/** Payload type for createFiscalRepCancellationRequest mutation */
export type CreateFiscalRepCancellationRequestPayload = {
  __typename?: 'CreateFiscalRepCancellationRequestPayload';
  fiscalRepCancellationRequest: FiscalRepCancellationRequest;
};

/** Input type for createFiscalRepSubscription mutation */
export type CreateFiscalRepSubscriptionInput = {
  data: FiscalRepSubscriptionCreateData;
};

/** Payload type for createFiscalRepSubscription mutation */
export type CreateFiscalRepSubscriptionPayload = {
  __typename?: 'CreateFiscalRepSubscriptionPayload';
  fiscalRepSubscription: FiscalRepSubscription;
};

/** Input type for createNifOrderComment mutation */
export type CreateNifOrderCommentInput = {
  data: NifOrderCommentCreateData;
};

/** Payload type for createNifOrderComment mutation */
export type CreateNifOrderCommentPayload = {
  __typename?: 'CreateNifOrderCommentPayload';
  nifOrderComment: NifOrderComment;
};

/** Input type for createNifOrder mutation */
export type CreateNifOrderInput = {
  data: NifOrderCreateData;
  withVoucher?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input type for createNifOrderIntakeDocument mutation */
export type CreateNifOrderIntakeDocumentInput = {
  data: NifOrderIntakeDocumentCreateData;
};

/** Payload type for createNifOrderIntakeDocument mutation */
export type CreateNifOrderIntakeDocumentPayload = {
  __typename?: 'CreateNifOrderIntakeDocumentPayload';
  nifOrderIntakeDocument: NifOrderIntakeDocument;
};

/** Payload type for createNifOrder mutation */
export type CreateNifOrderPayload = {
  __typename?: 'CreateNifOrderPayload';
  nifOrder: NifOrder;
};

/** Input type for createOrderComment mutation */
export type CreateOrderCommentInput = {
  data: OrderCommentCreateData;
};

/** Payload type for createOrderComment mutation */
export type CreateOrderCommentPayload = {
  __typename?: 'CreateOrderCommentPayload';
  orderComment: OrderComment;
};

/** Input type for createOrderVoucherCheckoutUrl mutation */
export type CreateOrderVoucherCheckoutUrlInput = {
  couponId?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  rewardfulReferralId?: InputMaybe<Scalars['String']['input']>;
  voucherType: OrderVoucherType;
};

/** Payload type for createOrderVoucherCheckoutUrl mutation */
export type CreateOrderVoucherCheckoutUrlPayload = {
  __typename?: 'CreateOrderVoucherCheckoutUrlPayload';
  url: Scalars['String']['output'];
};

/** Input type for createPresignedDownloadUrl mutation */
export type CreatePresignedDownloadUrlInput = {
  fileId: Scalars['Uuid']['input'];
};

/** Payload type for createPresignedDownloadUrl mutation */
export type CreatePresignedDownloadUrlPayload = {
  __typename?: 'CreatePresignedDownloadUrlPayload';
  url: Scalars['String']['output'];
};

/** Input type for createPresignedUploadUrl mutation */
export type CreatePresignedUploadUrlInput = {
  category: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
};

/** Payload type for createPresignedUploadUrl mutation */
export type CreatePresignedUploadUrlPayload = {
  __typename?: 'CreatePresignedUploadUrlPayload';
  fields?: Maybe<Array<PresignedUrlField>>;
  file: File;
  method: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Input type for createUpdateFiscalRepPaymentDetailsCheckoutUrl mutation */
export type CreateUpdateFiscalRepPaymentDetailsCheckoutUrlInput = {
  fiscalRepSubscriptionId: Scalars['Uuid']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** Payload type for createUpdateFiscalRepPaymentDetailsCheckoutUrl mutation */
export type CreateUpdateFiscalRepPaymentDetailsCheckoutUrlPayload = {
  __typename?: 'CreateUpdateFiscalRepPaymentDetailsCheckoutUrlPayload';
  checkoutUrl: Scalars['String']['output'];
};

/** Input type for createUser mutation */
export type CreateUserInput = {
  data: UserCreateData;
};

/** Payload type for createUser mutation */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  user: User;
};

/** Input type for createVendor mutation */
export type CreateVendorInput = {
  data: VendorCreateData;
};

/** Payload type for createVendor mutation */
export type CreateVendorPayload = {
  __typename?: 'CreateVendorPayload';
  vendor: Vendor;
};

export type CustomerPayment = {
  __typename?: 'CustomerPayment';
  amountCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isRefunded?: Maybe<Scalars['Boolean']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  userId: Scalars['Uuid']['output'];
};

/** Input type for deleteFiscalPasswordBulkUpload mutation */
export type DeleteFiscalPasswordBulkUploadInput = {
  id: Scalars['Uuid']['input'];
};

/** Payload type for deleteFiscalPasswordBulkUpload mutation */
export type DeleteFiscalPasswordBulkUploadPayload = {
  __typename?: 'DeleteFiscalPasswordBulkUploadPayload';
  fiscalPasswordBulkUpload: FiscalPasswordBulkUpload;
};

/** Input type for deleteFiscalPasswordRequest mutation */
export type DeleteFiscalPasswordRequestInput = {
  id: Scalars['Uuid']['input'];
};

/** Payload type for deleteFiscalPasswordRequest mutation */
export type DeleteFiscalPasswordRequestPayload = {
  __typename?: 'DeleteFiscalPasswordRequestPayload';
  fiscalPasswordRequest: FiscalPasswordRequest;
};

/** Input type for deleteFiscalRepCancellationRequest mutation */
export type DeleteFiscalRepCancellationRequestInput = {
  id: Scalars['Uuid']['input'];
};

/** Payload type for deleteFiscalRepCancellationRequest mutation */
export type DeleteFiscalRepCancellationRequestPayload = {
  __typename?: 'DeleteFiscalRepCancellationRequestPayload';
  fiscalRepCancellationRequest: FiscalRepCancellationRequest;
};

/** Input type for deleteFiscalRepSubscription mutation */
export type DeleteFiscalRepSubscriptionInput = {
  id: Scalars['Uuid']['input'];
};

/** Payload type for deleteFiscalRepSubscription mutation */
export type DeleteFiscalRepSubscriptionPayload = {
  __typename?: 'DeleteFiscalRepSubscriptionPayload';
  fiscalRepSubscription: FiscalRepSubscription;
};

/** Input type for deleteNifOrderComment mutation */
export type DeleteNifOrderCommentInput = {
  id: Scalars['Uuid']['input'];
};

/** Payload type for deleteNifOrderComment mutation */
export type DeleteNifOrderCommentPayload = {
  __typename?: 'DeleteNifOrderCommentPayload';
  nifOrderComment: NifOrderComment;
};

/** Input type for deleteNifOrder mutation */
export type DeleteNifOrderInput = {
  id: Scalars['Uuid']['input'];
};

/** Input type for deleteNifOrderIntakeDocument mutation */
export type DeleteNifOrderIntakeDocumentInput = {
  id: Scalars['Uuid']['input'];
};

/** Payload type for deleteNifOrderIntakeDocument mutation */
export type DeleteNifOrderIntakeDocumentPayload = {
  __typename?: 'DeleteNifOrderIntakeDocumentPayload';
  nifOrderIntakeDocument: NifOrderIntakeDocument;
};

/** Payload type for deleteNifOrder mutation */
export type DeleteNifOrderPayload = {
  __typename?: 'DeleteNifOrderPayload';
  nifOrder: NifOrder;
};

/** Input type for deleteOrderComment mutation */
export type DeleteOrderCommentInput = {
  id: Scalars['Uuid']['input'];
};

/** Payload type for deleteOrderComment mutation */
export type DeleteOrderCommentPayload = {
  __typename?: 'DeleteOrderCommentPayload';
  orderComment: OrderComment;
};

/** Input type for deleteUser mutation */
export type DeleteUserInput = {
  id: Scalars['Uuid']['input'];
};

/** Payload type for deleteUser mutation */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  user: User;
};

/** Input type for deleteVendor mutation */
export type DeleteVendorInput = {
  id: Scalars['Uuid']['input'];
};

/** Payload type for deleteVendor mutation */
export type DeleteVendorPayload = {
  __typename?: 'DeleteVendorPayload';
  vendor: Vendor;
};

export type DocumentReviewStatus =
  | 'APPROVED'
  | 'PENDING'
  | 'REJECTED';

export type EmbeddedVerifiableDocumentDataInput = {
  fileOne: FileUploadInput;
  fileTwo?: InputMaybe<FileUploadInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<VerifiableDocumentStatus>;
  type: VerifiableDocumentType;
};

/** Input type for extractPasswordsFromFile mutation */
export type ExtractPasswordsFromFileInput = {
  fileId: Scalars['Uuid']['input'];
};

export type ExtractPasswordsFromFilePage = {
  __typename?: 'ExtractPasswordsFromFilePage';
  fullName?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
};

/** Payload type for extractPasswordsFromFile mutation */
export type ExtractPasswordsFromFilePayload = {
  __typename?: 'ExtractPasswordsFromFilePayload';
  pages: Array<ExtractPasswordsFromFilePage>;
};

export type File = {
  __typename?: 'File';
  adapter: Scalars['String']['output'];
  category: Scalars['String']['output'];
  /** URL of the file where it is publicly hosted. Returns null if it is not publicly available. */
  hostedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type FileUploadInput = {
  id: Scalars['Uuid']['input'];
  /** Discarded but useful for forms */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FiscalPasswordBulkUpload = {
  __typename?: 'FiscalPasswordBulkUpload';
  bulkFile: File;
  bulkFileId: Scalars['Uuid']['output'];
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  unknownBulkFile?: Maybe<File>;
  unknownBulkFileId?: Maybe<Scalars['Uuid']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vendor: Vendor;
  vendorId: Scalars['Uuid']['output'];
};

export type FiscalPasswordBulkUploadUpdateData = {
  id?: InputMaybe<Scalars['Uuid']['input']>;
  vendorId?: InputMaybe<Scalars['Uuid']['input']>;
};

export type FiscalPasswordRequest = {
  __typename?: 'FiscalPasswordRequest';
  confirmationScreenshotFile?: Maybe<File>;
  createdAt: Scalars['DateTime']['output'];
  formScreenshotFile?: Maybe<File>;
  id: Scalars['ID']['output'];
  isQueued: Scalars['Boolean']['output'];
  isRecoveryFlow: Scalars['Boolean']['output'];
  nifNumber: Scalars['String']['output'];
  passwordReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  passwordRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  receivedPassword?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  requestError?: Maybe<Scalars['String']['output']>;
  secretAnswer: Scalars['String']['output'];
  secretQuestion: FiscalRepPasswordSecretQuestion;
  subscription: FiscalRepSubscription;
  subscriptionId: Scalars['Uuid']['output'];
  vendor?: Maybe<Vendor>;
  vendorId?: Maybe<Scalars['Uuid']['output']>;
};

export type FiscalPasswordRequestCreateData = {
  confirmationScreenshotFile?: InputMaybe<FileUploadInput>;
  formScreenshotFile?: InputMaybe<FileUploadInput>;
  isRecoveryFlow?: InputMaybe<Scalars['Boolean']['input']>;
  nifNumber: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  requestError?: InputMaybe<Scalars['String']['input']>;
  secretAnswer: Scalars['String']['input'];
  subscriptionId: Scalars['Uuid']['input'];
  vendorId?: InputMaybe<Scalars['Uuid']['input']>;
};

export type FiscalPasswordRequestUpdateData = {
  confirmationScreenshotFile?: InputMaybe<FileUploadInput>;
  formScreenshotFile?: InputMaybe<FileUploadInput>;
  isRecoveryFlow?: InputMaybe<Scalars['Boolean']['input']>;
  nifNumber?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  requestError?: InputMaybe<Scalars['String']['input']>;
  secretAnswer?: InputMaybe<Scalars['String']['input']>;
  secretQuestion?: InputMaybe<FiscalRepPasswordSecretQuestion>;
  subscriptionId?: InputMaybe<Scalars['Uuid']['input']>;
  vendorId?: InputMaybe<Scalars['Uuid']['input']>;
};

export type FiscalRepCancellationProofType =
  | 'CERTIFICATE_OF_RESIDENCE'
  | 'NHR_REGISTRATION_REQUEST'
  | 'PORTAL_SCREENSHOT'
  | 'UPDATED_NIF_DOCUMENT';

export type FiscalRepCancellationRequest = {
  __typename?: 'FiscalRepCancellationRequest';
  cancellationDocumentType?: Maybe<FiscalRepCancellationProofType>;
  completedSuccessfullyAt?: Maybe<Scalars['DateTime']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  contractUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fiscalRepSubscription: FiscalRepSubscription;
  fiscalRepSubscriptionId: Scalars['Uuid']['output'];
  id: Scalars['ID']['output'];
  isComplete: Scalars['Boolean']['output'];
  proofOfCancellationDocument?: Maybe<VerifiableDocument>;
  proofOfCancellationDocumentId?: Maybe<Scalars['Uuid']['output']>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  signedContractFile?: Maybe<File>;
  signedContractFileId?: Maybe<Scalars['Uuid']['output']>;
  type: FiscalRepCancellationType;
};

export type FiscalRepCancellationRequestCreateData = {
  cancellationDocumentType?: InputMaybe<FiscalRepCancellationProofType>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  contractUrl?: InputMaybe<Scalars['String']['input']>;
  fiscalRepSubscriptionId: Scalars['Uuid']['input'];
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  proofOfCancellationDocumentId?: InputMaybe<Scalars['Uuid']['input']>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  signedContractFileId?: InputMaybe<Scalars['Uuid']['input']>;
  type: FiscalRepCancellationType;
};

export type FiscalRepCancellationRequestUpdateData = {
  cancellationDocumentType?: InputMaybe<FiscalRepCancellationProofType>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  contractUrl?: InputMaybe<Scalars['String']['input']>;
  fiscalRepSubscriptionId?: InputMaybe<Scalars['Uuid']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  proofOfCancellationDocumentId?: InputMaybe<Scalars['Uuid']['input']>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  signedContractFileId?: InputMaybe<Scalars['Uuid']['input']>;
  type?: InputMaybe<FiscalRepCancellationType>;
};

export type FiscalRepCancellationType =
  | 'AGREEMENT_MEMORANDUM'
  | 'ELECTRONIC_NOTIFICATIONS'
  | 'PROOF_OF_FISCAL_REP_REMOVAL';

export type FiscalRepDocument = {
  __typename?: 'FiscalRepDocument';
  createdAt: Scalars['DateTime']['output'];
  file: File;
  fileId: Scalars['Uuid']['output'];
  id: Scalars['ID']['output'];
  passwordRequest?: Maybe<FiscalPasswordRequest>;
  portalPassword?: Maybe<Scalars['String']['output']>;
  subscription: FiscalRepSubscription;
  type: FiscalRepDocumentType;
};

export type FiscalRepDocumentRejectionReasonInput = {
  customReason?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['Uuid']['input']>;
};

export type FiscalRepDocumentType =
  | 'IMPOSTO_MUNICIPAL_SOBRE_IMOVEIS'
  | 'IMPOSTO_UNICO_CIRCULACAO'
  | 'OTHER'
  | 'PASSWORD';

export type FiscalRepPasswordSecretQuestion =
  | 'COR'
  | 'DESTINO'
  | 'FILME'
  | 'LIVRO'
  | 'MUSICA'
  | 'PECA'
  | 'SERIE';

export type FiscalRepSubscription = {
  __typename?: 'FiscalRepSubscription';
  address?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['Date']['output']>;
  cancellationRequests: Array<FiscalRepCancellationRequest>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerEmail?: Maybe<Scalars['String']['output']>;
  documents: Array<FiscalRepDocument>;
  /** @deprecated Use 'renewalDateTime' instead. */
  expiryDate: Scalars['Date']['output'];
  givenNames: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isRedacted?: Maybe<Scalars['Boolean']['output']>;
  isUnpaid: Scalars['Boolean']['output'];
  lastReminderEmailAt?: Maybe<Scalars['DateTime']['output']>;
  nifNumber: Scalars['String']['output'];
  passwordRequests: Array<FiscalPasswordRequest>;
  passwordSecretAnswer?: Maybe<Scalars['String']['output']>;
  passwordSecretQuestion?: Maybe<FiscalRepPasswordSecretQuestion>;
  renewalAmountCents?: Maybe<Scalars['Int']['output']>;
  renewalAmountCurrency?: Maybe<Scalars['String']['output']>;
  renewalCreditCardBrand?: Maybe<Scalars['String']['output']>;
  renewalCreditCardLastFour?: Maybe<Scalars['String']['output']>;
  renewalDateTime: Scalars['DateTime']['output'];
  renewalPaymentType?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  surname: Scalars['String']['output'];
  user: User;
  userId: Scalars['Uuid']['output'];
  vendor?: Maybe<Vendor>;
  vendorId?: Maybe<Scalars['Uuid']['output']>;
};

export type FiscalRepSubscriptionCreateData = {
  givenNames: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  lastReminderEmailAt?: InputMaybe<Scalars['DateTime']['input']>;
  nifNumber: Scalars['String']['input'];
  renewalDateTime: Scalars['DateTime']['input'];
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  surname: Scalars['String']['input'];
  userId: Scalars['Uuid']['input'];
  vendorId?: InputMaybe<Scalars['Uuid']['input']>;
};

export type FiscalRepSubscriptionStatusFilter =
  | 'ACTIVE'
  | 'CANCELLATION_IN_PROGRESS'
  | 'INACTIVE'
  | 'PAYMENT_ISSUES';

export type FiscalRepSubscriptionUpdateData = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  givenNames?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastReminderEmailAt?: InputMaybe<Scalars['DateTime']['input']>;
  nifNumber?: InputMaybe<Scalars['String']['input']>;
  passwordSecretAnswer?: InputMaybe<Scalars['String']['input']>;
  passwordSecretQuestion?: InputMaybe<FiscalRepPasswordSecretQuestion>;
  renewalDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Uuid']['input']>;
  vendorId?: InputMaybe<Scalars['Uuid']['input']>;
};

export type FiscalRepSubscriptionWhereInput = {
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FiscalRepSubscriptionStatusFilter>;
  userId?: InputMaybe<Scalars['Uuid']['input']>;
  vendorUserId?: InputMaybe<Scalars['Uuid']['input']>;
};

export type Gender =
  | 'DECLINE_TO_ANSWER'
  | 'FEMALE'
  | 'MALE'
  | 'OTHER';

/** Input type for initiateFiscalPasswordRequest mutation */
export type InitiateFiscalPasswordRequestInput = {
  fiscalRepSubscriptionId: Scalars['Uuid']['input'];
  isRecoveryFlow?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Payload type for initiateFiscalPasswordRequest mutation */
export type InitiateFiscalPasswordRequestPayload = {
  __typename?: 'InitiateFiscalPasswordRequestPayload';
  fiscalPasswordRequest: FiscalPasswordRequest;
};

export type MaritalStatus =
  | 'DIVORCED_SEPARATED'
  | 'DOMESTIC_PARTNERSHIP'
  | 'MARRIED'
  | 'SINGLE'
  | 'WIDOWED';

export type Mutation = {
  __typename?: 'Mutation';
  assignNifOrderVendor: AssignNifOrderVendorPayload;
  cancelFiscalRepCancellationRequest: CancelFiscalRepCancellationRequestPayload;
  cancelFiscalRepSubscription: CancelFiscalRepSubscriptionPayload;
  checkEsignatureContractStatus: CheckEsignatureContractStatusPayload;
  checkFiscalRepPaymentStatus: CheckFiscalRepPaymentStatusPayload;
  checkOrderVoucherPaymentStatus: CheckOrderVoucherPaymentStatusPayload;
  commentOnNifOrder: CommentOnNifOrderPayload;
  createBullBoardAuthCode: CreateBullBoardAuthCodePayload;
  createFiscalPasswordRequest: CreateFiscalPasswordRequestPayload;
  createFiscalRepCancellationRequest: CreateFiscalRepCancellationRequestPayload;
  createFiscalRepSubscription: CreateFiscalRepSubscriptionPayload;
  createNifOrder: CreateNifOrderPayload;
  createNifOrderComment: CreateNifOrderCommentPayload;
  createNifOrderIntakeDocument: CreateNifOrderIntakeDocumentPayload;
  createOrderComment: CreateOrderCommentPayload;
  createOrderVoucherCheckoutUrl: CreateOrderVoucherCheckoutUrlPayload;
  createPresignedDownloadUrl: CreatePresignedDownloadUrlPayload;
  createPresignedUploadUrl: CreatePresignedUploadUrlPayload;
  createUpdateFiscalRepPaymentDetailsCheckoutUrl: CreateUpdateFiscalRepPaymentDetailsCheckoutUrlPayload;
  createUser: CreateUserPayload;
  createVendor: CreateVendorPayload;
  deleteFiscalPasswordBulkUpload: DeleteFiscalPasswordBulkUploadPayload;
  deleteFiscalPasswordRequest: DeleteFiscalPasswordRequestPayload;
  deleteFiscalRepCancellationRequest: DeleteFiscalRepCancellationRequestPayload;
  deleteFiscalRepSubscription: DeleteFiscalRepSubscriptionPayload;
  deleteNifOrder: DeleteNifOrderPayload;
  deleteNifOrderComment: DeleteNifOrderCommentPayload;
  deleteNifOrderIntakeDocument: DeleteNifOrderIntakeDocumentPayload;
  deleteOrderComment: DeleteOrderCommentPayload;
  deleteUser: DeleteUserPayload;
  deleteVendor: DeleteVendorPayload;
  extractPasswordsFromFile: ExtractPasswordsFromFilePayload;
  initiateFiscalPasswordRequest: InitiateFiscalPasswordRequestPayload;
  refundNifOrder: RefundNifOrderPayload;
  refundOrderVoucher: RefundOrderVoucherPayload;
  registerUserAsCustomer: RegisterUserAsCustomerPayload;
  requestFiscalRepCancellation: RequestFiscalRepCancellationPayload;
  resendEmailVerification: ResendEmailVerificationPayload;
  resendFiscalRepDocuments: ResendFiscalRepDocumentsPayload;
  reuploadReviewableDocument: ReuploadReviewableDocumentPayload;
  reviewDocumentVersion: ReviewDocumentVersionPayload;
  reviewFiscalRepCancellationRequest: ReviewFiscalRepCancellationRequestPayload;
  submitNifOrderIntake: SubmitNifOrderIntakePayload;
  submitNifOrderIntakeReview: SubmitNifOrderIntakeReviewPayload;
  triggerFiscalPasswordRequestAutomation: TriggerFiscalPasswordRequestAutomationPayload;
  updateFiscalPasswordBulkUpload: UpdateFiscalPasswordBulkUploadPayload;
  updateFiscalPasswordRequest: UpdateFiscalPasswordRequestPayload;
  updateFiscalRepCancellationRequest: UpdateFiscalRepCancellationRequestPayload;
  updateFiscalRepSubscription: UpdateFiscalRepSubscriptionPayload;
  updateNifOrder: UpdateNifOrderPayload;
  updateNifOrderComment: UpdateNifOrderCommentPayload;
  updateOrderComment: UpdateOrderCommentPayload;
  updateUser: UpdateUserPayload;
  updateUserDetails: UpdateUserDetailsPayload;
  updateVendor: UpdateVendorPayload;
  uploadFiscalDocument: UploadFiscalDocumentPayload;
  uploadFiscalPasswordBulkFile: UploadFiscalPasswordBulkFilePayload;
  uploadNifDocument: UploadNifDocumentPayload;
  uploadNifOrderPoa: UploadNifOrderPoaPayload;
  uploadNifRequestConfirmation: UploadNifRequestConfirmationPayload;
};


export type MutationAssignNifOrderVendorArgs = {
  input: AssignNifOrderVendorInput;
};


export type MutationCancelFiscalRepCancellationRequestArgs = {
  input: CancelFiscalRepCancellationRequestInput;
};


export type MutationCancelFiscalRepSubscriptionArgs = {
  input: CancelFiscalRepSubscriptionInput;
};


export type MutationCheckEsignatureContractStatusArgs = {
  input: CheckEsignatureContractStatusInput;
};


export type MutationCheckFiscalRepPaymentStatusArgs = {
  input: CheckFiscalRepPaymentStatusInput;
};


export type MutationCheckOrderVoucherPaymentStatusArgs = {
  input: CheckOrderVoucherPaymentStatusInput;
};


export type MutationCommentOnNifOrderArgs = {
  input: CommentOnNifOrderInput;
};


export type MutationCreateFiscalPasswordRequestArgs = {
  input: CreateFiscalPasswordRequestInput;
};


export type MutationCreateFiscalRepCancellationRequestArgs = {
  input: CreateFiscalRepCancellationRequestInput;
};


export type MutationCreateFiscalRepSubscriptionArgs = {
  input: CreateFiscalRepSubscriptionInput;
};


export type MutationCreateNifOrderArgs = {
  input: CreateNifOrderInput;
};


export type MutationCreateNifOrderCommentArgs = {
  input: CreateNifOrderCommentInput;
};


export type MutationCreateNifOrderIntakeDocumentArgs = {
  input: CreateNifOrderIntakeDocumentInput;
};


export type MutationCreateOrderCommentArgs = {
  input: CreateOrderCommentInput;
};


export type MutationCreateOrderVoucherCheckoutUrlArgs = {
  input: CreateOrderVoucherCheckoutUrlInput;
};


export type MutationCreatePresignedDownloadUrlArgs = {
  input: CreatePresignedDownloadUrlInput;
};


export type MutationCreatePresignedUploadUrlArgs = {
  input: CreatePresignedUploadUrlInput;
};


export type MutationCreateUpdateFiscalRepPaymentDetailsCheckoutUrlArgs = {
  input: CreateUpdateFiscalRepPaymentDetailsCheckoutUrlInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateVendorArgs = {
  input: CreateVendorInput;
};


export type MutationDeleteFiscalPasswordBulkUploadArgs = {
  input: DeleteFiscalPasswordBulkUploadInput;
};


export type MutationDeleteFiscalPasswordRequestArgs = {
  input: DeleteFiscalPasswordRequestInput;
};


export type MutationDeleteFiscalRepCancellationRequestArgs = {
  input: DeleteFiscalRepCancellationRequestInput;
};


export type MutationDeleteFiscalRepSubscriptionArgs = {
  input: DeleteFiscalRepSubscriptionInput;
};


export type MutationDeleteNifOrderArgs = {
  input: DeleteNifOrderInput;
};


export type MutationDeleteNifOrderCommentArgs = {
  input: DeleteNifOrderCommentInput;
};


export type MutationDeleteNifOrderIntakeDocumentArgs = {
  input: DeleteNifOrderIntakeDocumentInput;
};


export type MutationDeleteOrderCommentArgs = {
  input: DeleteOrderCommentInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDeleteVendorArgs = {
  input: DeleteVendorInput;
};


export type MutationExtractPasswordsFromFileArgs = {
  input: ExtractPasswordsFromFileInput;
};


export type MutationInitiateFiscalPasswordRequestArgs = {
  input: InitiateFiscalPasswordRequestInput;
};


export type MutationRefundNifOrderArgs = {
  input: RefundNifOrderInput;
};


export type MutationRefundOrderVoucherArgs = {
  input: RefundOrderVoucherInput;
};


export type MutationRegisterUserAsCustomerArgs = {
  input: RegisterUserAsCustomerInput;
};


export type MutationRequestFiscalRepCancellationArgs = {
  input: RequestFiscalRepCancellationInput;
};


export type MutationResendFiscalRepDocumentsArgs = {
  input: ResendFiscalRepDocumentsInput;
};


export type MutationReuploadReviewableDocumentArgs = {
  input: ReuploadReviewableDocumentInput;
};


export type MutationReviewDocumentVersionArgs = {
  input: ReviewDocumentVersionInput;
};


export type MutationReviewFiscalRepCancellationRequestArgs = {
  input: ReviewFiscalRepCancellationRequestInput;
};


export type MutationSubmitNifOrderIntakeArgs = {
  input: SubmitNifOrderIntakeInput;
};


export type MutationSubmitNifOrderIntakeReviewArgs = {
  input: SubmitNifOrderIntakeReviewInput;
};


export type MutationTriggerFiscalPasswordRequestAutomationArgs = {
  input: TriggerFiscalPasswordRequestAutomationInput;
};


export type MutationUpdateFiscalPasswordBulkUploadArgs = {
  input: UpdateFiscalPasswordBulkUploadInput;
};


export type MutationUpdateFiscalPasswordRequestArgs = {
  input: UpdateFiscalPasswordRequestInput;
};


export type MutationUpdateFiscalRepCancellationRequestArgs = {
  input: UpdateFiscalRepCancellationRequestInput;
};


export type MutationUpdateFiscalRepSubscriptionArgs = {
  input: UpdateFiscalRepSubscriptionInput;
};


export type MutationUpdateNifOrderArgs = {
  input: UpdateNifOrderInput;
};


export type MutationUpdateNifOrderCommentArgs = {
  input: UpdateNifOrderCommentInput;
};


export type MutationUpdateOrderCommentArgs = {
  input: UpdateOrderCommentInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserDetailsArgs = {
  input: UpdateUserDetailsInput;
};


export type MutationUpdateVendorArgs = {
  input: UpdateVendorInput;
};


export type MutationUploadFiscalDocumentArgs = {
  input: UploadFiscalDocumentInput;
};


export type MutationUploadFiscalPasswordBulkFileArgs = {
  input: UploadFiscalPasswordBulkFileInput;
};


export type MutationUploadNifDocumentArgs = {
  input: UploadNifDocumentInput;
};


export type MutationUploadNifOrderPoaArgs = {
  input: UploadNifOrderPoaInput;
};


export type MutationUploadNifRequestConfirmationArgs = {
  input: UploadNifRequestConfirmationInput;
};

export type NifDocumentUploadPasswordRequestInput = {
  referenceNumber: Scalars['String']['input'];
  secretAnswer: Scalars['String']['input'];
  secretQuestion: FiscalRepPasswordSecretQuestion;
};

export type NifOrder = {
  __typename?: 'NifOrder';
  additionalDocuments: Array<NifOrderAdditionalDocument>;
  address?: Maybe<NifOrderAddress>;
  birthCertificate?: Maybe<VerifiableDocument>;
  birthCertificateId?: Maybe<Scalars['Uuid']['output']>;
  birthCountry: Scalars['String']['output'];
  birthDate: Scalars['Date']['output'];
  comments: Array<NifOrderComment>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerEmail?: Maybe<Scalars['String']['output']>;
  documentExpirationDate: Scalars['Date']['output'];
  documentIssuingCountry: Scalars['String']['output'];
  documentNumber: Scalars['String']['output'];
  documentType: VerifiableDocumentType;
  fiscalRepDeclarationFile?: Maybe<File>;
  gender?: Maybe<Gender>;
  givenNames: Scalars['String']['output'];
  hasCompletedPasswordRequest: Scalars['Boolean']['output'];
  hasPasswordRequest: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  intakeDocuments: Array<NifOrderIntakeDocument>;
  intakeFlow?: Maybe<NifOrderIntakeFlow>;
  intakeSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  isPortugueseCitizen?: Maybe<Scalars['Boolean']['output']>;
  isRedacted: Scalars['Boolean']['output'];
  maritalStatus?: Maybe<MaritalStatus>;
  needsUpdatedInfo?: Maybe<Scalars['Boolean']['output']>;
  nifDocumentFile?: Maybe<File>;
  nifDocumentFileId?: Maybe<Scalars['Uuid']['output']>;
  nifNumber?: Maybe<Scalars['String']['output']>;
  orderAuditEvents: Array<OrderAuditEvent>;
  orderComments: Array<OrderComment>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  parents: Array<NifOrderParent>;
  payment?: Maybe<CustomerPayment>;
  paymentId?: Maybe<Scalars['Uuid']['output']>;
  poaFile?: Maybe<File>;
  poaFileId?: Maybe<Scalars['Uuid']['output']>;
  poaFileUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  poaRejectionReason?: Maybe<Scalars['String']['output']>;
  poaTemplateFile?: Maybe<File>;
  proofOfAddress?: Maybe<VerifiableDocument>;
  proofOfAddressId?: Maybe<Scalars['Uuid']['output']>;
  proofOfIdentity?: Maybe<VerifiableDocument>;
  proofOfIdentityDocumentType?: Maybe<ReviewableDocumentType>;
  proofOfIdentityDocumentTypeId?: Maybe<Scalars['Uuid']['output']>;
  proofOfIdentityId?: Maybe<Scalars['Uuid']['output']>;
  requestConfirmationFile?: Maybe<File>;
  requestConfirmationFileId?: Maybe<Scalars['Uuid']['output']>;
  status: NifOrderStatus;
  submitedAt?: Maybe<Scalars['DateTime']['output']>;
  surname: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['Uuid']['output'];
  usesReviewableDocumentFlow: Scalars['Boolean']['output'];
  vendor?: Maybe<Vendor>;
  vendorComments: Array<OrderComment>;
  vendorId?: Maybe<Scalars['Uuid']['output']>;
};

export type NifOrderAdditionalDocument = {
  __typename?: 'NifOrderAdditionalDocument';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nifOrder: NifOrder;
  nifOrderId: Scalars['Uuid']['output'];
  title: Scalars['String']['output'];
  translatedDescription: Scalars['String']['output'];
  translatedTitle: Scalars['String']['output'];
  type?: Maybe<NifOrderAdditionalDocumentType>;
  typeId?: Maybe<Scalars['Uuid']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  verifiableDocument?: Maybe<VerifiableDocument>;
  verifiableDocumentId?: Maybe<Scalars['Uuid']['output']>;
};


export type NifOrderAdditionalDocumentTranslatedDescriptionArgs = {
  locale: Scalars['String']['input'];
};


export type NifOrderAdditionalDocumentTranslatedTitleArgs = {
  locale: Scalars['String']['input'];
};

export type NifOrderAdditionalDocumentType = {
  __typename?: 'NifOrderAdditionalDocumentType';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type NifOrderAddress = {
  __typename?: 'NifOrderAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lineOne: Scalars['String']['output'];
  lineTwo?: Maybe<Scalars['String']['output']>;
  nifOrder: NifOrder;
  postalCode: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
};

export type NifOrderComment = {
  __typename?: 'NifOrderComment';
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['Uuid']['output']>;
  id: Scalars['ID']['output'];
  nifOrder: NifOrder;
  nifOrderId: Scalars['Uuid']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type NifOrderCommentCreateData = {
  comment: Scalars['String']['input'];
  creatorId?: InputMaybe<Scalars['Uuid']['input']>;
  nifOrderId: Scalars['Uuid']['input'];
};

export type NifOrderCommentUpdateData = {
  comment?: InputMaybe<Scalars['String']['input']>;
  creatorId?: InputMaybe<Scalars['Uuid']['input']>;
  nifOrderId?: InputMaybe<Scalars['Uuid']['input']>;
};

export type NifOrderCreateData = {
  additionalDocuments?: InputMaybe<Array<NifOrderEmbeddedAdditionalDocumentsData>>;
  address?: InputMaybe<NifOrderEmbeddedAddressData>;
  birthCountry: Scalars['String']['input'];
  birthDate: Scalars['Date']['input'];
  documentExpirationDate: Scalars['Date']['input'];
  documentIssuingCountry: Scalars['String']['input'];
  documentNumber: Scalars['String']['input'];
  documentType: VerifiableDocumentType;
  fiscalRepDeclarationFile?: InputMaybe<FileUploadInput>;
  gender?: InputMaybe<Gender>;
  givenNames: Scalars['String']['input'];
  maritalStatus?: InputMaybe<MaritalStatus>;
  needsUpdatedInfo?: InputMaybe<Scalars['Boolean']['input']>;
  nifDocumentFile?: InputMaybe<FileUploadInput>;
  parents?: InputMaybe<Array<NifOrderEmbeddedParentsData>>;
  poaFile?: InputMaybe<FileUploadInput>;
  poaTemplateFile?: InputMaybe<FileUploadInput>;
  proofOfIdentityDocumentTypeId?: InputMaybe<Scalars['Uuid']['input']>;
  requestConfirmationFile?: InputMaybe<FileUploadInput>;
  surname: Scalars['String']['input'];
  userId: Scalars['Uuid']['input'];
  vendorId?: InputMaybe<Scalars['Uuid']['input']>;
};

export type NifOrderEmbeddedAdditionalDocumentsData = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Uuid']['input']>;
  title: Scalars['String']['input'];
  typeId?: InputMaybe<Scalars['Uuid']['input']>;
  verifiableDocument?: InputMaybe<EmbeddedVerifiableDocumentDataInput>;
};

export type NifOrderEmbeddedAddressData = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  lineOne: Scalars['String']['input'];
  lineTwo?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
};

export type NifOrderEmbeddedParentsData = {
  documentNumber: Scalars['String']['input'];
  givenNames: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Uuid']['input']>;
  intakeDocuments?: InputMaybe<Array<NifOrderIntakeDocumentInput>>;
  position: Scalars['Int']['input'];
  proofOfIdentity?: InputMaybe<EmbeddedVerifiableDocumentDataInput>;
  surname: Scalars['String']['input'];
};

export type NifOrderIntakeDocument = {
  __typename?: 'NifOrderIntakeDocument';
  createdAt: Scalars['DateTime']['output'];
  documentCategory: ReviewableDocumentCategory;
  documentCategoryId: Scalars['Uuid']['output'];
  id: Scalars['ID']['output'];
  nifOrder: NifOrder;
  nifOrderId: Scalars['Uuid']['output'];
  parent?: Maybe<NifOrderParent>;
  parentId?: Maybe<Scalars['Uuid']['output']>;
  reviewableDocument: ReviewableDocument;
  titleTranslated: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type NifOrderIntakeDocumentTitleTranslatedArgs = {
  locale: Scalars['String']['input'];
};

export type NifOrderIntakeDocumentCreateData = {
  currentVersion?: InputMaybe<ReviewableDocumentVersionInput>;
  customDescription?: InputMaybe<Scalars['String']['input']>;
  customTitle?: InputMaybe<Scalars['String']['input']>;
  documentCategoryId: Scalars['Uuid']['input'];
  documentTypeId?: InputMaybe<Scalars['Uuid']['input']>;
  nifOrderId: Scalars['Uuid']['input'];
  parentId?: InputMaybe<Scalars['Uuid']['input']>;
};

export type NifOrderIntakeDocumentInput = {
  documentCategoryId: Scalars['Uuid']['input'];
  reviewableDocument?: InputMaybe<ReviewableDocumentInput>;
};

export type NifOrderIntakeFlow = {
  __typename?: 'NifOrderIntakeFlow';
  id: Scalars['ID']['output'];
  stage: NifOrderIntakeFlowStage;
};

export type NifOrderIntakeFlowStage =
  | 'ADMIN_REVIEW'
  | 'COMPLETE'
  | 'CUSTOMER_INTAKE'
  | 'CUSTOMER_REUPLOAD';

export type NifOrderParent = {
  __typename?: 'NifOrderParent';
  documentNumber: Scalars['String']['output'];
  givenNames: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  intakeDocuments: Array<NifOrderIntakeDocument>;
  nifOrder: NifOrder;
  nifOrderId: Scalars['Uuid']['output'];
  position: Scalars['Int']['output'];
  proofOfIdentity?: Maybe<VerifiableDocument>;
  proofOfIdentityId?: Maybe<Scalars['Uuid']['output']>;
  surname: Scalars['String']['output'];
};

export type NifOrderStatus =
  | 'AWAITING_INTAKE'
  | 'CANCELLED'
  | 'DRAFT'
  | 'INTAKE_REVIEW'
  | 'NIF_RECEIVED'
  | 'NIF_REQUESTED'
  | 'PAYMENT_PENDING'
  | 'POA_PENDING'
  | 'POA_RECEIVED'
  | 'POA_TO_BE_SENT';

export type NifOrderUpdateData = {
  additionalDocuments?: InputMaybe<Array<NifOrderEmbeddedAdditionalDocumentsData>>;
  address?: InputMaybe<NifOrderEmbeddedAddressData>;
  birthCertificate?: InputMaybe<EmbeddedVerifiableDocumentDataInput>;
  birthCountry?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentExpirationDate?: InputMaybe<Scalars['Date']['input']>;
  documentIssuingCountry?: InputMaybe<Scalars['String']['input']>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<VerifiableDocumentType>;
  fiscalRepDeclarationFile?: InputMaybe<FileUploadInput>;
  gender?: InputMaybe<Gender>;
  givenNames?: InputMaybe<Scalars['String']['input']>;
  intakeDocuments?: InputMaybe<Array<NifOrderIntakeDocumentInput>>;
  isPortugueseCitizen?: InputMaybe<Scalars['Boolean']['input']>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  needsUpdatedInfo?: InputMaybe<Scalars['Boolean']['input']>;
  nifDocumentFile?: InputMaybe<FileUploadInput>;
  nifNumber?: InputMaybe<Scalars['String']['input']>;
  parents?: InputMaybe<Array<NifOrderEmbeddedParentsData>>;
  poaFile?: InputMaybe<FileUploadInput>;
  poaRejectionReason?: InputMaybe<Scalars['String']['input']>;
  poaTemplateFile?: InputMaybe<FileUploadInput>;
  proofOfAddress?: InputMaybe<EmbeddedVerifiableDocumentDataInput>;
  proofOfIdentity?: InputMaybe<EmbeddedVerifiableDocumentDataInput>;
  proofOfIdentityDocumentTypeId?: InputMaybe<Scalars['Uuid']['input']>;
  requestConfirmationFile?: InputMaybe<FileUploadInput>;
  status?: InputMaybe<NifOrderStatus>;
  submitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Uuid']['input']>;
  vendorId?: InputMaybe<Scalars['Uuid']['input']>;
};

export type NifOrderWhereInput = {
  isReadyForVendor?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Uuid']['input']>;
  vendorUserId?: InputMaybe<Scalars['Uuid']['input']>;
};

export type OrderAuditEvent = {
  __typename?: 'OrderAuditEvent';
  accountType?: Maybe<AccountType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  nifOrder?: Maybe<NifOrder>;
  nifOrderId?: Maybe<Scalars['Uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  structuredNotes?: Maybe<Scalars['Json']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  user?: Maybe<User>;
  userAction?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Uuid']['output']>;
  userIdPreserved?: Maybe<Scalars['Uuid']['output']>;
  vendor?: Maybe<Vendor>;
  vendorIdPreserved?: Maybe<Scalars['Uuid']['output']>;
};

export type OrderComment = {
  __typename?: 'OrderComment';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  threadType: AccountType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userAccountType: AccountType;
  userId?: Maybe<Scalars['Uuid']['output']>;
  userIdPreserved: Scalars['String']['output'];
  vendor?: Maybe<Vendor>;
};

export type OrderCommentCreateData = {
  content: Scalars['String']['input'];
  nifOrderId?: InputMaybe<Scalars['Uuid']['input']>;
  threadType: AccountType;
  userAccountType: AccountType;
  vendorId?: InputMaybe<Scalars['Uuid']['input']>;
};

export type OrderCommentUpdateData = {
  content?: InputMaybe<Scalars['String']['input']>;
};

export type OrderTranslatableOption = {
  __typename?: 'OrderTranslatableOption';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameTranslated: Scalars['String']['output'];
  type: OrderTranslatableOptionType;
  updatedAt: Scalars['DateTime']['output'];
};


export type OrderTranslatableOptionNameTranslatedArgs = {
  locale: Scalars['String']['input'];
};

export type OrderTranslatableOptionType =
  | 'BANK_ACCOUNT'
  | 'BANK_ACCOUNT_ACCESS_ISSUES'
  | 'BANK_ACCOUNT_DEPOSIT_AMOUNT'
  | 'BANK_ACCOUNT_HOLDER_ASSET_AMOUNT'
  | 'BANK_ACCOUNT_HOLDER_EDUCATION_LEVEL'
  | 'BANK_ACCOUNT_HOLDER_FINANCIAL_SOURCE'
  | 'BANK_ACCOUNT_HOLDER_PROFESSION'
  | 'BANK_ACCOUNT_OPENING_PURPOSE'
  | 'BANK_OPENING_DOCUMENT_NAME'
  | 'BANK_OPENING_DOCUMENT_REVIEWABLE_SECTION_NAME';

export type OrderVoucher = {
  __typename?: 'OrderVoucher';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  payment?: Maybe<CustomerPayment>;
  paymentId?: Maybe<Scalars['Uuid']['output']>;
  quantity: Scalars['Int']['output'];
  type: OrderVoucherType;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['Uuid']['output'];
};

export type OrderVoucherType =
  | 'IN_PERSON_BANK'
  | 'NIF'
  | 'REMOTE_BANK';

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PresignedUrlField = {
  __typename?: 'PresignedUrlField';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  fiscalPasswordBulkUpload: FiscalPasswordBulkUpload;
  fiscalPasswordBulkUploads: Array<FiscalPasswordBulkUpload>;
  fiscalPasswordRequest: FiscalPasswordRequest;
  fiscalPasswordRequests: Array<FiscalPasswordRequest>;
  fiscalRepCancellationRequest: FiscalRepCancellationRequest;
  fiscalRepCancellationRequests: Array<FiscalRepCancellationRequest>;
  fiscalRepDocuments: Array<FiscalRepDocument>;
  fiscalRepSubscription: FiscalRepSubscription;
  fiscalRepSubscriptions: Array<FiscalRepSubscription>;
  fiscalRepSubscriptionsConnection: FiscalRepSubscriptionConnection;
  nifOrder: NifOrder;
  nifOrderAdditionalDocumentType: NifOrderAdditionalDocumentType;
  nifOrderAdditionalDocumentTypes: Array<NifOrderAdditionalDocumentType>;
  nifOrderComment: NifOrderComment;
  nifOrderComments: Array<NifOrderComment>;
  nifOrders: Array<NifOrder>;
  orderAuditEvent: OrderAuditEvent;
  orderAuditEvents: Array<OrderAuditEvent>;
  orderTranslatableOption: OrderTranslatableOption;
  orderTranslatableOptions: Array<OrderTranslatableOption>;
  reviewableDocumentRejectionOption: ReviewableDocumentRejectionOption;
  reviewableDocumentRejectionOptions: Array<ReviewableDocumentRejectionOption>;
  user: User;
  users: Array<User>;
  usersConnection: UserConnection;
  vendor: Vendor;
  vendors: Array<Vendor>;
  verifiableDocumentRejectionType: VerifiableDocumentRejectionType;
  verifiableDocumentRejectionTypes: Array<VerifiableDocumentRejectionType>;
};


export type QueryFiscalPasswordBulkUploadArgs = {
  id: Scalars['Uuid']['input'];
};


export type QueryFiscalPasswordRequestArgs = {
  id: Scalars['Uuid']['input'];
};


export type QueryFiscalRepCancellationRequestArgs = {
  id: Scalars['Uuid']['input'];
};


export type QueryFiscalRepDocumentsArgs = {
  userId: Scalars['Uuid']['input'];
};


export type QueryFiscalRepSubscriptionArgs = {
  id: Scalars['Uuid']['input'];
};


export type QueryFiscalRepSubscriptionsArgs = {
  where?: InputMaybe<FiscalRepSubscriptionWhereInput>;
};


export type QueryFiscalRepSubscriptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FiscalRepSubscriptionWhereInput>;
};


export type QueryNifOrderArgs = {
  id: Scalars['Uuid']['input'];
};


export type QueryNifOrderAdditionalDocumentTypeArgs = {
  id: Scalars['Uuid']['input'];
};


export type QueryNifOrderCommentArgs = {
  id: Scalars['Uuid']['input'];
};


export type QueryNifOrdersArgs = {
  where?: InputMaybe<NifOrderWhereInput>;
};


export type QueryOrderAuditEventArgs = {
  id: Scalars['Uuid']['input'];
};


export type QueryOrderTranslatableOptionArgs = {
  id: Scalars['Uuid']['input'];
};


export type QueryOrderTranslatableOptionsArgs = {
  type: OrderTranslatableOptionType;
};


export type QueryReviewableDocumentRejectionOptionArgs = {
  id: Scalars['Uuid']['input'];
};


export type QueryUserArgs = {
  id: Scalars['Uuid']['input'];
};


export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVendorArgs = {
  id: Scalars['Uuid']['input'];
};


export type QueryVerifiableDocumentRejectionTypeArgs = {
  id: Scalars['Uuid']['input'];
};

/** Input type for refundNifOrder mutation */
export type RefundNifOrderInput = {
  nifOrderId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/** Payload type for refundNifOrder mutation */
export type RefundNifOrderPayload = {
  __typename?: 'RefundNifOrderPayload';
  nifOrder: NifOrder;
};

/** Input type for refundOrderVoucher mutation */
export type RefundOrderVoucherInput = {
  id: Scalars['String']['input'];
};

/** Payload type for refundOrderVoucher mutation */
export type RefundOrderVoucherPayload = {
  __typename?: 'RefundOrderVoucherPayload';
  orderVoucher: OrderVoucher;
};

/** Input type for registerUserAsCustomer mutation */
export type RegisterUserAsCustomerInput = {
  couponId?: InputMaybe<Scalars['String']['input']>;
  rewardfulReferralId?: InputMaybe<Scalars['String']['input']>;
};

/** Payload type for registerUserAsCustomer mutation */
export type RegisterUserAsCustomerPayload = {
  __typename?: 'RegisterUserAsCustomerPayload';
  user: User;
};

/** Input type for requestFiscalRepCancellation mutation */
export type RequestFiscalRepCancellationInput = {
  cancellationType?: InputMaybe<FiscalRepCancellationType>;
  documentType?: InputMaybe<FiscalRepCancellationProofType>;
  proofOfCancellationDocument?: InputMaybe<EmbeddedVerifiableDocumentDataInput>;
  subscriptionId: Scalars['Uuid']['input'];
};

/** Payload type for requestFiscalRepCancellation mutation */
export type RequestFiscalRepCancellationPayload = {
  __typename?: 'RequestFiscalRepCancellationPayload';
  subscription: FiscalRepSubscription;
};

/** Payload type for resendEmailVerification mutation */
export type ResendEmailVerificationPayload = {
  __typename?: 'ResendEmailVerificationPayload';
  success: Scalars['Boolean']['output'];
};

/** Input type for resendFiscalRepDocuments mutation */
export type ResendFiscalRepDocumentsInput = {
  documentIds: Array<Scalars['Uuid']['input']>;
  subscriptionId: Scalars['Uuid']['input'];
};

/** Payload type for resendFiscalRepDocuments mutation */
export type ResendFiscalRepDocumentsPayload = {
  __typename?: 'ResendFiscalRepDocumentsPayload';
  success: Scalars['Boolean']['output'];
};

/** Input type for reuploadReviewableDocument mutation */
export type ReuploadReviewableDocumentInput = {
  input: ReviewableDocumentInput;
  reviewableDocumentId: Scalars['Uuid']['input'];
};

/** Payload type for reuploadReviewableDocument mutation */
export type ReuploadReviewableDocumentPayload = {
  __typename?: 'ReuploadReviewableDocumentPayload';
  reviewableDocument: ReviewableDocument;
};

/** Input type for reviewDocumentVersion mutation */
export type ReviewDocumentVersionInput = {
  id: Scalars['String']['input'];
  rejectionReasons?: InputMaybe<Array<ReviewDocumentVersionRejectionReasonInput>>;
  reviewerType: ReviewableDocumentReviewerType;
};

/** Payload type for reviewDocumentVersion mutation */
export type ReviewDocumentVersionPayload = {
  __typename?: 'ReviewDocumentVersionPayload';
  version: ReviewableDocumentVersion;
};

export type ReviewDocumentVersionRejectionReasonInput = {
  customReason?: InputMaybe<Scalars['String']['input']>;
  rejectionOptionId?: InputMaybe<Scalars['Uuid']['input']>;
};

/** Input type for reviewFiscalRepCancellationRequest mutation */
export type ReviewFiscalRepCancellationRequestInput = {
  id: Scalars['Uuid']['input'];
  rejectionReasons?: InputMaybe<Array<FiscalRepDocumentRejectionReasonInput>>;
  status: VerifiableDocumentStatus;
};

/** Payload type for reviewFiscalRepCancellationRequest mutation */
export type ReviewFiscalRepCancellationRequestPayload = {
  __typename?: 'ReviewFiscalRepCancellationRequestPayload';
  subscription: FiscalRepSubscription;
};

export type ReviewableDocument = {
  __typename?: 'ReviewableDocument';
  category: ReviewableDocumentCategory;
  categoryId: Scalars['Uuid']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentVersion?: Maybe<ReviewableDocumentVersion>;
  customDescription?: Maybe<Scalars['String']['output']>;
  customTitle?: Maybe<Scalars['String']['output']>;
  descriptionTranslated?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<ReviewableDocumentType>;
  documentTypeId?: Maybe<Scalars['Uuid']['output']>;
  flow: ReviewableDocumentFlow;
  id: Scalars['ID']['output'];
  titleTranslated?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Uuid']['output'];
  versions: Array<ReviewableDocumentVersion>;
};


export type ReviewableDocumentDescriptionTranslatedArgs = {
  locale: Scalars['String']['input'];
};


export type ReviewableDocumentTitleTranslatedArgs = {
  locale: Scalars['String']['input'];
};

export type ReviewableDocumentCategory = {
  __typename?: 'ReviewableDocumentCategory';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ReviewableDocumentFlow =
  | 'NIF_INTAKE';

export type ReviewableDocumentInput = {
  currentVersion: ReviewableDocumentVersionInput;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewableDocumentRejectionOption = {
  __typename?: 'ReviewableDocumentRejectionOption';
  adminReason: Scalars['String']['output'];
  categories: Array<ReviewableDocumentRejectionOptionDocumentCategory>;
  customerReason: Scalars['String']['output'];
  documentTypes: Array<ReviewableDocumentRejectionOptionDocumentType>;
  flow?: Maybe<ReviewableDocumentFlow>;
  id: Scalars['ID']['output'];
  isSanityCheck: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  reviewerType?: Maybe<ReviewableDocumentReviewerType>;
};

export type ReviewableDocumentRejectionOptionDocumentCategory = {
  __typename?: 'ReviewableDocumentRejectionOptionDocumentCategory';
  category: ReviewableDocumentCategory;
  categoryId: Scalars['Uuid']['output'];
  rejectionOption: ReviewableDocumentRejectionOption;
  rejectionOptionId: Scalars['Uuid']['output'];
};

export type ReviewableDocumentRejectionOptionDocumentType = {
  __typename?: 'ReviewableDocumentRejectionOptionDocumentType';
  documentType: ReviewableDocumentType;
  documentTypeId: Scalars['Uuid']['output'];
  rejectionOption: ReviewableDocumentRejectionOption;
  rejectionOptionId: Scalars['Uuid']['output'];
};

export type ReviewableDocumentRejectionReason = {
  __typename?: 'ReviewableDocumentRejectionReason';
  customReason?: Maybe<Scalars['String']['output']>;
  documentReviewId: Scalars['Uuid']['output'];
  id: Scalars['ID']['output'];
  rejectionOption?: Maybe<ReviewableDocumentRejectionOption>;
  rejectionOptionId?: Maybe<Scalars['Uuid']['output']>;
  review: ReviewableDocumentReview;
};

export type ReviewableDocumentReview = {
  __typename?: 'ReviewableDocumentReview';
  documentVersionId: Scalars['Uuid']['output'];
  id: Scalars['ID']['output'];
  isApproved: Scalars['Boolean']['output'];
  rejectionReasons: Array<ReviewableDocumentRejectionReason>;
  reviewerId: Scalars['Uuid']['output'];
  reviewerType: ReviewableDocumentReviewerType;
};

export type ReviewableDocumentReviewerType =
  | 'ADMIN'
  | 'CUSTOMER'
  | 'VENDOR_BANK'
  | 'VENDOR_LAWYER';

export type ReviewableDocumentType = {
  __typename?: 'ReviewableDocumentType';
  categories: Array<ReviewableDocumentTypeCategory>;
  description?: Maybe<Scalars['String']['output']>;
  hasTwoFiles: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rejectionOptions: Array<ReviewableDocumentRejectionOptionDocumentType>;
};

export type ReviewableDocumentTypeCategory = {
  __typename?: 'ReviewableDocumentTypeCategory';
  category: ReviewableDocumentCategory;
  categoryId: Scalars['Uuid']['output'];
  documentType: ReviewableDocumentType;
  documentTypeId: Scalars['Uuid']['output'];
};

export type ReviewableDocumentVersion = {
  __typename?: 'ReviewableDocumentVersion';
  createdAt: Scalars['DateTime']['output'];
  documentType: ReviewableDocumentType;
  documentTypeId: Scalars['Uuid']['output'];
  fileOne: File;
  fileOneId: Scalars['Uuid']['output'];
  fileTwo?: Maybe<File>;
  fileTwoId?: Maybe<Scalars['Uuid']['output']>;
  id: Scalars['ID']['output'];
  isLive: Scalars['Boolean']['output'];
  reviewableDocumentId: Scalars['Uuid']['output'];
  reviews: Array<ReviewableDocumentReview>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReviewableDocumentVersionInput = {
  documentTypeId: Scalars['String']['input'];
  fileOne: FileUploadInput;
  fileTwo?: InputMaybe<FileUploadInput>;
};

/** Input type for submitNifOrderIntake mutation */
export type SubmitNifOrderIntakeInput = {
  nifOrderId: Scalars['String']['input'];
};

/** Payload type for submitNifOrderIntake mutation */
export type SubmitNifOrderIntakePayload = {
  __typename?: 'SubmitNifOrderIntakePayload';
  nifOrder: NifOrder;
};

/** Input type for submitNifOrderIntakeReview mutation */
export type SubmitNifOrderIntakeReviewInput = {
  nifOrderId: Scalars['Uuid']['input'];
};

/** Payload type for submitNifOrderIntakeReview mutation */
export type SubmitNifOrderIntakeReviewPayload = {
  __typename?: 'SubmitNifOrderIntakeReviewPayload';
  nifOrder: NifOrder;
};

/** Input type for triggerFiscalPasswordRequestAutomation mutation */
export type TriggerFiscalPasswordRequestAutomationInput = {
  id: Scalars['Uuid']['input'];
};

/** Payload type for triggerFiscalPasswordRequestAutomation mutation */
export type TriggerFiscalPasswordRequestAutomationPayload = {
  __typename?: 'TriggerFiscalPasswordRequestAutomationPayload';
  fiscalPasswordRequest: FiscalPasswordRequest;
};

/** Input type for updateFiscalPasswordBulkUpload mutation */
export type UpdateFiscalPasswordBulkUploadInput = {
  data: FiscalPasswordBulkUploadUpdateData;
  id: Scalars['Uuid']['input'];
};

/** Payload type for updateFiscalPasswordBulkUpload mutation */
export type UpdateFiscalPasswordBulkUploadPayload = {
  __typename?: 'UpdateFiscalPasswordBulkUploadPayload';
  fiscalPasswordBulkUpload: FiscalPasswordBulkUpload;
};

/** Input type for updateFiscalPasswordRequest mutation */
export type UpdateFiscalPasswordRequestInput = {
  data: FiscalPasswordRequestUpdateData;
  id: Scalars['Uuid']['input'];
};

/** Payload type for updateFiscalPasswordRequest mutation */
export type UpdateFiscalPasswordRequestPayload = {
  __typename?: 'UpdateFiscalPasswordRequestPayload';
  fiscalPasswordRequest: FiscalPasswordRequest;
};

/** Input type for updateFiscalRepCancellationRequest mutation */
export type UpdateFiscalRepCancellationRequestInput = {
  data: FiscalRepCancellationRequestUpdateData;
  id: Scalars['Uuid']['input'];
};

/** Payload type for updateFiscalRepCancellationRequest mutation */
export type UpdateFiscalRepCancellationRequestPayload = {
  __typename?: 'UpdateFiscalRepCancellationRequestPayload';
  fiscalRepCancellationRequest: FiscalRepCancellationRequest;
};

/** Input type for updateFiscalRepSubscription mutation */
export type UpdateFiscalRepSubscriptionInput = {
  data: FiscalRepSubscriptionUpdateData;
  id: Scalars['Uuid']['input'];
};

/** Payload type for updateFiscalRepSubscription mutation */
export type UpdateFiscalRepSubscriptionPayload = {
  __typename?: 'UpdateFiscalRepSubscriptionPayload';
  fiscalRepSubscription: FiscalRepSubscription;
};

/** Input type for updateNifOrderComment mutation */
export type UpdateNifOrderCommentInput = {
  data: NifOrderCommentUpdateData;
  id: Scalars['Uuid']['input'];
};

/** Payload type for updateNifOrderComment mutation */
export type UpdateNifOrderCommentPayload = {
  __typename?: 'UpdateNifOrderCommentPayload';
  nifOrderComment: NifOrderComment;
};

/** Input type for updateNifOrder mutation */
export type UpdateNifOrderInput = {
  data: NifOrderUpdateData;
  id: Scalars['Uuid']['input'];
};

/** Payload type for updateNifOrder mutation */
export type UpdateNifOrderPayload = {
  __typename?: 'UpdateNifOrderPayload';
  nifOrder: NifOrder;
};

/** Input type for updateOrderComment mutation */
export type UpdateOrderCommentInput = {
  data: OrderCommentUpdateData;
  id: Scalars['Uuid']['input'];
};

/** Payload type for updateOrderComment mutation */
export type UpdateOrderCommentPayload = {
  __typename?: 'UpdateOrderCommentPayload';
  orderComment: OrderComment;
};

/** Input type for updateUserDetails mutation */
export type UpdateUserDetailsInput = {
  isSubscribedToMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Payload type for updateUserDetails mutation */
export type UpdateUserDetailsPayload = {
  __typename?: 'UpdateUserDetailsPayload';
  user: User;
};

/** Input type for updateUser mutation */
export type UpdateUserInput = {
  data: UserUpdateData;
  id: Scalars['Uuid']['input'];
};

/** Payload type for updateUser mutation */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  user: User;
};

/** Input type for updateVendor mutation */
export type UpdateVendorInput = {
  data: VendorUpdateData;
  id: Scalars['Uuid']['input'];
};

/** Payload type for updateVendor mutation */
export type UpdateVendorPayload = {
  __typename?: 'UpdateVendorPayload';
  vendor: Vendor;
};

/** Input type for uploadFiscalDocument mutation */
export type UploadFiscalDocumentInput = {
  file: FileUploadInput;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['Uuid']['input'];
  type: FiscalRepDocumentType;
};

/** Payload type for uploadFiscalDocument mutation */
export type UploadFiscalDocumentPayload = {
  __typename?: 'UploadFiscalDocumentPayload';
  fiscalRepDocument: FiscalRepDocument;
};

/** Input type for uploadFiscalPasswordBulkFile mutation */
export type UploadFiscalPasswordBulkFileInput = {
  file: FileUploadInput;
  vendorId: Scalars['Uuid']['input'];
};

/** Payload type for uploadFiscalPasswordBulkFile mutation */
export type UploadFiscalPasswordBulkFilePayload = {
  __typename?: 'UploadFiscalPasswordBulkFilePayload';
  fiscalPasswordBulkUploadId: Scalars['Uuid']['output'];
  jobId: Scalars['String']['output'];
};

/** Input type for uploadNifDocument mutation */
export type UploadNifDocumentInput = {
  nifDocumentFile: FileUploadInput;
  nifNumber: Scalars['String']['input'];
  nifOrderId: Scalars['Uuid']['input'];
  presubmittedPasswordRequest?: InputMaybe<NifDocumentUploadPasswordRequestInput>;
};

/** Payload type for uploadNifDocument mutation */
export type UploadNifDocumentPayload = {
  __typename?: 'UploadNifDocumentPayload';
  nifOrder: NifOrder;
};

/** Input type for uploadNifOrderPoa mutation */
export type UploadNifOrderPoaInput = {
  nifOrderId: Scalars['Uuid']['input'];
  poaFile: FileUploadInput;
};

/** Payload type for uploadNifOrderPoa mutation */
export type UploadNifOrderPoaPayload = {
  __typename?: 'UploadNifOrderPoaPayload';
  nifOrder: NifOrder;
};

/** Input type for uploadNifRequestConfirmation mutation */
export type UploadNifRequestConfirmationInput = {
  nifOrderId: Scalars['Uuid']['input'];
  requestConfirmationFile: FileUploadInput;
};

/** Payload type for uploadNifRequestConfirmation mutation */
export type UploadNifRequestConfirmationPayload = {
  __typename?: 'UploadNifRequestConfirmationPayload';
  nifOrder: NifOrder;
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<UserCustomer>;
  email: Scalars['String']['output'];
  emailSuppressedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isEmailSuppressed: Scalars['Boolean']['output'];
  isRegistered: Scalars['Boolean']['output'];
  isSubscribedToMarketing?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderAuditEvents: Array<OrderAuditEvent>;
  orderVouchers: Array<OrderVoucher>;
  roles: Array<UserRole>;
  updatedAt: Scalars['DateTime']['output'];
  vendors: Array<VendorUser>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
};

export type UserCreateData = {
  email: Scalars['String']['input'];
  isRegistered: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<UserEmbeddedRolesData>>;
};

export type UserCustomer = {
  __typename?: 'UserCustomer';
  id: Scalars['ID']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserEmbeddedRolesData = {
  role: Scalars['String']['input'];
};

export type UserRole = {
  __typename?: 'UserRole';
  role: Scalars['String']['output'];
  user: User;
  userId: Scalars['Uuid']['output'];
};

export type UserUpdateData = {
  email?: InputMaybe<Scalars['String']['input']>;
  isRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<UserEmbeddedRolesData>>;
};

export type Vendor = {
  __typename?: 'Vendor';
  address: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nifInfo?: Maybe<VendorNifInfo>;
  nifOrders: Array<NifOrder>;
  users: Array<VendorUser>;
};

export type VendorCreateData = {
  address: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nifInfo?: InputMaybe<VendorEmbeddedNifInfoData>;
  users?: InputMaybe<Array<VendorEmbeddedUsersData>>;
};

export type VendorEmbeddedNifInfoData = {
  defaultSecretQuestion?: InputMaybe<FiscalRepPasswordSecretQuestion>;
  fiscalRepDeclarationTemplateId: Scalars['String']['input'];
  isPasswordRequester?: InputMaybe<Scalars['Boolean']['input']>;
  powerOfAttorneyAdultTemplateId: Scalars['String']['input'];
  powerOfAttorneyMinorTemplateId: Scalars['String']['input'];
};

export type VendorEmbeddedUsersData = {
  userId: Scalars['Uuid']['input'];
};

export type VendorNifInfo = {
  __typename?: 'VendorNifInfo';
  defaultSecretQuestion?: Maybe<FiscalRepPasswordSecretQuestion>;
  fiscalRepDeclarationTemplateId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPasswordRequester: Scalars['Boolean']['output'];
  powerOfAttorneyAdultTemplateId: Scalars['String']['output'];
  powerOfAttorneyMinorTemplateId: Scalars['String']['output'];
  vendor: Vendor;
};

export type VendorUpdateData = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nifInfo?: InputMaybe<VendorEmbeddedNifInfoData>;
  users?: InputMaybe<Array<VendorEmbeddedUsersData>>;
};

export type VendorUser = {
  __typename?: 'VendorUser';
  user: User;
  userId: Scalars['Uuid']['output'];
  vendor: Vendor;
  vendorId: Scalars['Uuid']['output'];
};

export type VerifiableDocument = {
  __typename?: 'VerifiableDocument';
  createdAt: Scalars['DateTime']['output'];
  fileOne: File;
  fileOneId: Scalars['Uuid']['output'];
  fileTwo?: Maybe<File>;
  fileTwoId?: Maybe<Scalars['Uuid']['output']>;
  id: Scalars['ID']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  rejectionReasons: Array<VerifiableDocumentRejectionReason>;
  status: VerifiableDocumentStatus;
  title: Scalars['String']['output'];
  type: VerifiableDocumentType;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Uuid']['output'];
};

export type VerifiableDocumentRejectionReason = {
  __typename?: 'VerifiableDocumentRejectionReason';
  createdAt: Scalars['DateTime']['output'];
  customReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  type?: Maybe<VerifiableDocumentRejectionType>;
  typeId?: Maybe<Scalars['Uuid']['output']>;
};

export type VerifiableDocumentRejectionType = {
  __typename?: 'VerifiableDocumentRejectionType';
  customerReason: Scalars['String']['output'];
  customerReasonKey: Scalars['String']['output'];
  documents: Array<VerifiableDocumentRejectionTypeDocument>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type VerifiableDocumentRejectionTypeDocument = {
  __typename?: 'VerifiableDocumentRejectionTypeDocument';
  rejectionTypeId: Scalars['Uuid']['output'];
  verifiableDocumentType: VerifiableDocumentType;
};

export type VerifiableDocumentStatus =
  | 'ACCEPTED'
  | 'PENDING'
  | 'REJECTED';

export type VerifiableDocumentType =
  | 'ADDITIONAL_DOCUMENT'
  | 'BANK_STATEMENT'
  | 'BIRTH_CERTIFICATE'
  | 'DRIVER_LICENSE'
  | 'EU_ID'
  | 'FISCAL_REP_CANCELLATION_REQUEST'
  | 'PASSPORT'
  | 'PORTUGUESE_BIRTH_CERTIFICATE'
  | 'PROOF_OF_EMPLOYMENT'
  | 'UTILITY_BILL';

export type FiscalRepSubscriptionConnection = {
  __typename?: 'fiscalRepSubscriptionConnection';
  edges: Array<FiscalRepSubscriptionEdge>;
  pageInfo: PageInfo;
};

export type FiscalRepSubscriptionEdge = {
  __typename?: 'fiscalRepSubscriptionEdge';
  cursor: Scalars['String']['output'];
  node: FiscalRepSubscription;
};

export type FileInputFragment = { __typename?: 'File', id: string, name: string };

export type CreateUploadUrlMutationVariables = Exact<{
  input: CreatePresignedUploadUrlInput;
}>;


export type CreateUploadUrlMutation = { __typename?: 'Mutation', createPresignedUploadUrl: { __typename?: 'CreatePresignedUploadUrlPayload', url: string, method: string, fields?: Array<{ __typename?: 'PresignedUrlField', name: string, value: string }> | null, file: { __typename?: 'File', id: string, name: string } } };

export type GetPresignedDownloadUrlMutationVariables = Exact<{
  input: CreatePresignedDownloadUrlInput;
}>;


export type GetPresignedDownloadUrlMutation = { __typename?: 'Mutation', createPresignedDownloadUrl: { __typename?: 'CreatePresignedDownloadUrlPayload', url: string } };

export type CurrentUserFragment = { __typename?: 'User', id: string, email: string, name?: string | null, isRegistered: boolean, isSubscribedToMarketing?: boolean | null, locale?: string | null, isEmailSuppressed: boolean };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['Uuid']['input'];
}>;


export type GetUserByIdQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, email: string, name?: string | null, isRegistered: boolean, isSubscribedToMarketing?: boolean | null, locale?: string | null, isEmailSuppressed: boolean } };

export type UpdateUserDetailsMutationVariables = Exact<{
  input: UpdateUserDetailsInput;
}>;


export type UpdateUserDetailsMutation = { __typename?: 'Mutation', updateUserDetails: { __typename?: 'UpdateUserDetailsPayload', user: { __typename?: 'User', id: string, email: string, name?: string | null, isRegistered: boolean, isSubscribedToMarketing?: boolean | null, locale?: string | null, isEmailSuppressed: boolean } } };

export type RegisterUserAsCustomerMutationVariables = Exact<{
  input: RegisterUserAsCustomerInput;
}>;


export type RegisterUserAsCustomerMutation = { __typename?: 'Mutation', registerUserAsCustomer: { __typename?: 'RegisterUserAsCustomerPayload', user: { __typename?: 'User', id: string, email: string, name?: string | null, isRegistered: boolean, isSubscribedToMarketing?: boolean | null, locale?: string | null, isEmailSuppressed: boolean } } };

export type ResendEmailVerificationMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendEmailVerificationMutation = { __typename?: 'Mutation', resendEmailVerification: { __typename?: 'ResendEmailVerificationPayload', success: boolean } };

export type FiscalRepSubscriptionRowFragment = { __typename?: 'FiscalRepSubscription', id: string, givenNames: string, surname: string, isActive: boolean, renewalDateTime: string, createdAt: string, nifNumber: string, isUnpaid: boolean, cancelledAt?: string | null, renewalAmountCurrency?: string | null, renewalAmountCents?: number | null, renewalCreditCardBrand?: string | null, renewalCreditCardLastFour?: string | null, renewalPaymentType?: string | null, stripeSubscriptionId?: string | null, cancellationRequests: Array<{ __typename?: 'FiscalRepCancellationRequest', id: string, isComplete: boolean, cancellationDocumentType?: FiscalRepCancellationProofType | null, type: FiscalRepCancellationType, contractUrl?: string | null, signedContractFileId?: string | null, createdAt: string, completedSuccessfullyAt?: string | null, proofOfCancellationDocument?: { __typename?: 'VerifiableDocument', id: string, status: VerifiableDocumentStatus } | null }> };

export type CreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutationVariables = Exact<{
  input: CreateUpdateFiscalRepPaymentDetailsCheckoutUrlInput;
}>;


export type CreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutation = { __typename?: 'Mutation', createUpdateFiscalRepPaymentDetailsCheckoutUrl: { __typename?: 'CreateUpdateFiscalRepPaymentDetailsCheckoutUrlPayload', checkoutUrl: string } };

export type GetOrdersQueryVariables = Exact<{
  userId: Scalars['Uuid']['input'];
}>;


export type GetOrdersQuery = { __typename?: 'Query', nifOrders: Array<{ __typename: 'NifOrder', id: string, givenNames: string, surname: string, status: NifOrderStatus, nifNumber?: string | null, hasPasswordRequest: boolean, hasCompletedPasswordRequest: boolean, createdAt: string, nifDocumentFile?: { __typename?: 'File', id: string } | null }>, fiscalRepSubscriptions: Array<{ __typename?: 'FiscalRepSubscription', id: string, givenNames: string, surname: string, isActive: boolean, renewalDateTime: string, createdAt: string, nifNumber: string, isUnpaid: boolean, cancelledAt?: string | null, renewalAmountCurrency?: string | null, renewalAmountCents?: number | null, renewalCreditCardBrand?: string | null, renewalCreditCardLastFour?: string | null, renewalPaymentType?: string | null, stripeSubscriptionId?: string | null, cancellationRequests: Array<{ __typename?: 'FiscalRepCancellationRequest', id: string, isComplete: boolean, cancellationDocumentType?: FiscalRepCancellationProofType | null, type: FiscalRepCancellationType, contractUrl?: string | null, signedContractFileId?: string | null, createdAt: string, completedSuccessfullyAt?: string | null, proofOfCancellationDocument?: { __typename?: 'VerifiableDocument', id: string, status: VerifiableDocumentStatus } | null }> }>, user: { __typename?: 'User', id: string, orderVouchers: Array<{ __typename?: 'OrderVoucher', id: string, type: OrderVoucherType, quantity: number }> } };

export type OrderVoucherFragment = { __typename?: 'OrderVoucher', id: string, type: OrderVoucherType, quantity: number };

export type DeleteNifOrderMutationVariables = Exact<{
  id: Scalars['Uuid']['input'];
}>;


export type DeleteNifOrderMutation = { __typename?: 'Mutation', deleteNifOrder: { __typename?: 'DeleteNifOrderPayload', nifOrder: { __typename?: 'NifOrder', id: string, user: { __typename?: 'User', id: string, orderVouchers: Array<{ __typename?: 'OrderVoucher', id: string, type: OrderVoucherType, quantity: number }> } } } };

export type CheckFiscalRepPaymentStatusMutationVariables = Exact<{
  input: CheckFiscalRepPaymentStatusInput;
}>;


export type CheckFiscalRepPaymentStatusMutation = { __typename?: 'Mutation', checkFiscalRepPaymentStatus: { __typename?: 'CheckFiscalRepPaymentStatusPayload', fiscalRepSubscription: { __typename?: 'FiscalRepSubscription', id: string, givenNames: string, surname: string, isActive: boolean, renewalDateTime: string, createdAt: string, nifNumber: string, isUnpaid: boolean, cancelledAt?: string | null, renewalAmountCurrency?: string | null, renewalAmountCents?: number | null, renewalCreditCardBrand?: string | null, renewalCreditCardLastFour?: string | null, renewalPaymentType?: string | null, stripeSubscriptionId?: string | null, cancellationRequests: Array<{ __typename?: 'FiscalRepCancellationRequest', id: string, isComplete: boolean, cancellationDocumentType?: FiscalRepCancellationProofType | null, type: FiscalRepCancellationType, contractUrl?: string | null, signedContractFileId?: string | null, createdAt: string, completedSuccessfullyAt?: string | null, proofOfCancellationDocument?: { __typename?: 'VerifiableDocument', id: string, status: VerifiableDocumentStatus } | null }> } } };

export type CheckOrderVoucherPaymentStatusMutationVariables = Exact<{
  input: CheckOrderVoucherPaymentStatusInput;
}>;


export type CheckOrderVoucherPaymentStatusMutation = { __typename?: 'Mutation', checkOrderVoucherPaymentStatus: { __typename?: 'CheckOrderVoucherPaymentStatusPayload', user: { __typename?: 'User', id: string, orderVouchers: Array<{ __typename?: 'OrderVoucher', id: string, type: OrderVoucherType, quantity: number }> } } };

export type CheckEsignatureContractStatusMutationVariables = Exact<{
  input: CheckEsignatureContractStatusInput;
}>;


export type CheckEsignatureContractStatusMutation = { __typename?: 'Mutation', checkEsignatureContractStatus: { __typename?: 'CheckEsignatureContractStatusPayload', didUpdate: boolean } };

export type FiscalRepDocumentFragment = { __typename?: 'FiscalRepDocument', id: string, fileId: string, createdAt: string, type: FiscalRepDocumentType, portalPassword?: string | null, subscription: { __typename?: 'FiscalRepSubscription', id: string, givenNames: string, surname: string } };

export type NifOrderDocumentFragment = { __typename?: 'NifOrder', id: string, nifDocumentFileId?: string | null, givenNames: string, surname: string, nifNumber?: string | null, completedAt?: string | null, nifDocumentFile?: { __typename?: 'File', id: string, name: string } | null };

export type GetDocumentsQueryVariables = Exact<{
  userId: Scalars['Uuid']['input'];
}>;


export type GetDocumentsQuery = { __typename?: 'Query', fiscalRepDocuments: Array<{ __typename?: 'FiscalRepDocument', id: string, fileId: string, createdAt: string, type: FiscalRepDocumentType, portalPassword?: string | null, subscription: { __typename?: 'FiscalRepSubscription', id: string, givenNames: string, surname: string } }>, nifOrders: Array<{ __typename?: 'NifOrder', id: string, nifDocumentFileId?: string | null, givenNames: string, surname: string, nifNumber?: string | null, completedAt?: string | null, nifDocumentFile?: { __typename?: 'File', id: string, name: string } | null }> };

export type ReviewableDocumentTypeFragment = { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string, hasTwoFiles: boolean };

export type ReviewableDocumentFragment = { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null };

export type ReviewableDocumentWithTitleDescriptionFragment = { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, titleTranslated?: string | null, descriptionTranslated?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null };

export type ReuploadReviewableDocumentMutationVariables = Exact<{
  input: ReuploadReviewableDocumentInput;
  locale: Scalars['String']['input'];
}>;


export type ReuploadReviewableDocumentMutation = { __typename?: 'Mutation', reuploadReviewableDocument: { __typename?: 'ReuploadReviewableDocumentPayload', reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, titleTranslated?: string | null, descriptionTranslated?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } } };

export type FiscalRepresentationByIdQueryVariables = Exact<{
  id: Scalars['Uuid']['input'];
}>;


export type FiscalRepresentationByIdQuery = { __typename?: 'Query', fiscalRepSubscription: { __typename?: 'FiscalRepSubscription', id: string, givenNames: string, surname: string, isActive: boolean, renewalDateTime: string, createdAt: string, nifNumber: string, isUnpaid: boolean, cancelledAt?: string | null, renewalAmountCurrency?: string | null, renewalAmountCents?: number | null, renewalCreditCardBrand?: string | null, renewalCreditCardLastFour?: string | null, renewalPaymentType?: string | null, stripeSubscriptionId?: string | null, cancellationRequests: Array<{ __typename?: 'FiscalRepCancellationRequest', id: string, isComplete: boolean, cancellationDocumentType?: FiscalRepCancellationProofType | null, type: FiscalRepCancellationType, contractUrl?: string | null, signedContractFileId?: string | null, createdAt: string, completedSuccessfullyAt?: string | null, proofOfCancellationDocument?: { __typename?: 'VerifiableDocument', id: string, status: VerifiableDocumentStatus } | null }> } };

export type RequestFiscalRepCancellationMutationVariables = Exact<{
  input: RequestFiscalRepCancellationInput;
}>;


export type RequestFiscalRepCancellationMutation = { __typename?: 'Mutation', requestFiscalRepCancellation: { __typename?: 'RequestFiscalRepCancellationPayload', subscription: { __typename?: 'FiscalRepSubscription', id: string, givenNames: string, surname: string, isActive: boolean, renewalDateTime: string, createdAt: string, nifNumber: string, isUnpaid: boolean, cancelledAt?: string | null, renewalAmountCurrency?: string | null, renewalAmountCents?: number | null, renewalCreditCardBrand?: string | null, renewalCreditCardLastFour?: string | null, renewalPaymentType?: string | null, stripeSubscriptionId?: string | null, cancellationRequests: Array<{ __typename?: 'FiscalRepCancellationRequest', id: string, isComplete: boolean, cancellationDocumentType?: FiscalRepCancellationProofType | null, type: FiscalRepCancellationType, contractUrl?: string | null, signedContractFileId?: string | null, createdAt: string, completedSuccessfullyAt?: string | null, proofOfCancellationDocument?: { __typename?: 'VerifiableDocument', id: string, status: VerifiableDocumentStatus } | null }> } } };

export type VerifiableDocumentFragment = { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null };

export type NifOrderRowFragment = { __typename: 'NifOrder', id: string, givenNames: string, surname: string, status: NifOrderStatus, nifNumber?: string | null, hasPasswordRequest: boolean, hasCompletedPasswordRequest: boolean, createdAt: string, nifDocumentFile?: { __typename?: 'File', id: string } | null };

export type NifOrderFragment = { __typename?: 'NifOrder', id: string, givenNames: string, surname: string, birthDate: string, birthCountry: string, documentType: VerifiableDocumentType, documentNumber: string, documentIssuingCountry: string, documentExpirationDate: string, isPortugueseCitizen?: boolean | null, proofOfAddressId?: string | null, submitedAt?: string | null, status: NifOrderStatus, paidAt?: string | null, gender?: Gender | null, maritalStatus?: MaritalStatus | null, proofOfIdentityDocumentTypeId?: string | null, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, birthCertificate?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, parents: Array<{ __typename?: 'NifOrderParent', id: string, position: number, givenNames: string, surname: string, documentNumber: string, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }> }>, address?: { __typename?: 'NifOrderAddress', id: string, lineOne: string, lineTwo?: string | null, city: string, region?: string | null, postalCode: string, country: string } | null, proofOfAddress?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, nifDocumentFile?: { __typename?: 'File', id: string } | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }>, proofOfIdentityDocumentType?: { __typename?: 'ReviewableDocumentType', id: string, key: string } | null };

export type GetNifOrderRowQueryVariables = Exact<{
  id: Scalars['Uuid']['input'];
}>;


export type GetNifOrderRowQuery = { __typename?: 'Query', nifOrder: { __typename: 'NifOrder', id: string, givenNames: string, surname: string, status: NifOrderStatus, nifNumber?: string | null, hasPasswordRequest: boolean, hasCompletedPasswordRequest: boolean, createdAt: string, nifDocumentFile?: { __typename?: 'File', id: string } | null } };

export type GetNifOrderFullQueryVariables = Exact<{
  id: Scalars['Uuid']['input'];
}>;


export type GetNifOrderFullQuery = { __typename?: 'Query', nifOrder: { __typename?: 'NifOrder', id: string, givenNames: string, surname: string, birthDate: string, birthCountry: string, documentType: VerifiableDocumentType, documentNumber: string, documentIssuingCountry: string, documentExpirationDate: string, isPortugueseCitizen?: boolean | null, proofOfAddressId?: string | null, submitedAt?: string | null, status: NifOrderStatus, paidAt?: string | null, gender?: Gender | null, maritalStatus?: MaritalStatus | null, proofOfIdentityDocumentTypeId?: string | null, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, birthCertificate?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, parents: Array<{ __typename?: 'NifOrderParent', id: string, position: number, givenNames: string, surname: string, documentNumber: string, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }> }>, address?: { __typename?: 'NifOrderAddress', id: string, lineOne: string, lineTwo?: string | null, city: string, region?: string | null, postalCode: string, country: string } | null, proofOfAddress?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, nifDocumentFile?: { __typename?: 'File', id: string } | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }>, proofOfIdentityDocumentType?: { __typename?: 'ReviewableDocumentType', id: string, key: string } | null } };

export type NifOrderWithAdditionalDocumentsFragment = { __typename?: 'NifOrder', id: string, givenNames: string, surname: string, birthDate: string, birthCountry: string, documentType: VerifiableDocumentType, documentNumber: string, documentIssuingCountry: string, documentExpirationDate: string, isPortugueseCitizen?: boolean | null, proofOfAddressId?: string | null, submitedAt?: string | null, status: NifOrderStatus, paidAt?: string | null, gender?: Gender | null, maritalStatus?: MaritalStatus | null, proofOfIdentityDocumentTypeId?: string | null, additionalDocuments: Array<{ __typename?: 'NifOrderAdditionalDocument', id: string, translatedTitle: string, translatedDescription: string, createdAt: string, verifiableDocument?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null }>, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, birthCertificate?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, parents: Array<{ __typename?: 'NifOrderParent', id: string, position: number, givenNames: string, surname: string, documentNumber: string, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }> }>, address?: { __typename?: 'NifOrderAddress', id: string, lineOne: string, lineTwo?: string | null, city: string, region?: string | null, postalCode: string, country: string } | null, proofOfAddress?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, nifDocumentFile?: { __typename?: 'File', id: string } | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }>, proofOfIdentityDocumentType?: { __typename?: 'ReviewableDocumentType', id: string, key: string } | null };

export type GetNifOrderWithAdditionalDocumentsQueryVariables = Exact<{
  id: Scalars['Uuid']['input'];
  locale: Scalars['String']['input'];
}>;


export type GetNifOrderWithAdditionalDocumentsQuery = { __typename?: 'Query', nifOrder: { __typename?: 'NifOrder', id: string, givenNames: string, surname: string, birthDate: string, birthCountry: string, documentType: VerifiableDocumentType, documentNumber: string, documentIssuingCountry: string, documentExpirationDate: string, isPortugueseCitizen?: boolean | null, proofOfAddressId?: string | null, submitedAt?: string | null, status: NifOrderStatus, paidAt?: string | null, gender?: Gender | null, maritalStatus?: MaritalStatus | null, proofOfIdentityDocumentTypeId?: string | null, additionalDocuments: Array<{ __typename?: 'NifOrderAdditionalDocument', id: string, translatedTitle: string, translatedDescription: string, createdAt: string, verifiableDocument?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null }>, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, birthCertificate?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, parents: Array<{ __typename?: 'NifOrderParent', id: string, position: number, givenNames: string, surname: string, documentNumber: string, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }> }>, address?: { __typename?: 'NifOrderAddress', id: string, lineOne: string, lineTwo?: string | null, city: string, region?: string | null, postalCode: string, country: string } | null, proofOfAddress?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, nifDocumentFile?: { __typename?: 'File', id: string } | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }>, proofOfIdentityDocumentType?: { __typename?: 'ReviewableDocumentType', id: string, key: string } | null } };

export type CreateNifOrderMutationVariables = Exact<{
  input: CreateNifOrderInput;
}>;


export type CreateNifOrderMutation = { __typename?: 'Mutation', createNifOrder: { __typename?: 'CreateNifOrderPayload', nifOrder: { __typename?: 'NifOrder', id: string, givenNames: string, surname: string, birthDate: string, birthCountry: string, documentType: VerifiableDocumentType, documentNumber: string, documentIssuingCountry: string, documentExpirationDate: string, isPortugueseCitizen?: boolean | null, proofOfAddressId?: string | null, submitedAt?: string | null, status: NifOrderStatus, paidAt?: string | null, gender?: Gender | null, maritalStatus?: MaritalStatus | null, proofOfIdentityDocumentTypeId?: string | null, user: { __typename?: 'User', id: string, orderVouchers: Array<{ __typename?: 'OrderVoucher', id: string, type: OrderVoucherType, quantity: number }> }, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, birthCertificate?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, parents: Array<{ __typename?: 'NifOrderParent', id: string, position: number, givenNames: string, surname: string, documentNumber: string, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }> }>, address?: { __typename?: 'NifOrderAddress', id: string, lineOne: string, lineTwo?: string | null, city: string, region?: string | null, postalCode: string, country: string } | null, proofOfAddress?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, nifDocumentFile?: { __typename?: 'File', id: string } | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }>, proofOfIdentityDocumentType?: { __typename?: 'ReviewableDocumentType', id: string, key: string } | null } } };

export type UpdateNifOrderMutationVariables = Exact<{
  input: UpdateNifOrderInput;
}>;


export type UpdateNifOrderMutation = { __typename?: 'Mutation', updateNifOrder: { __typename?: 'UpdateNifOrderPayload', nifOrder: { __typename?: 'NifOrder', id: string, givenNames: string, surname: string, birthDate: string, birthCountry: string, documentType: VerifiableDocumentType, documentNumber: string, documentIssuingCountry: string, documentExpirationDate: string, isPortugueseCitizen?: boolean | null, proofOfAddressId?: string | null, submitedAt?: string | null, status: NifOrderStatus, paidAt?: string | null, gender?: Gender | null, maritalStatus?: MaritalStatus | null, proofOfIdentityDocumentTypeId?: string | null, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, birthCertificate?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, parents: Array<{ __typename?: 'NifOrderParent', id: string, position: number, givenNames: string, surname: string, documentNumber: string, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }> }>, address?: { __typename?: 'NifOrderAddress', id: string, lineOne: string, lineTwo?: string | null, city: string, region?: string | null, postalCode: string, country: string } | null, proofOfAddress?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, nifDocumentFile?: { __typename?: 'File', id: string } | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }>, proofOfIdentityDocumentType?: { __typename?: 'ReviewableDocumentType', id: string, key: string } | null } } };

export type SubmitNifOrderIntakeMutationVariables = Exact<{
  input: SubmitNifOrderIntakeInput;
}>;


export type SubmitNifOrderIntakeMutation = { __typename?: 'Mutation', submitNifOrderIntake: { __typename?: 'SubmitNifOrderIntakePayload', nifOrder: { __typename?: 'NifOrder', id: string, givenNames: string, surname: string, birthDate: string, birthCountry: string, documentType: VerifiableDocumentType, documentNumber: string, documentIssuingCountry: string, documentExpirationDate: string, isPortugueseCitizen?: boolean | null, proofOfAddressId?: string | null, submitedAt?: string | null, status: NifOrderStatus, paidAt?: string | null, gender?: Gender | null, maritalStatus?: MaritalStatus | null, proofOfIdentityDocumentTypeId?: string | null, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, birthCertificate?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, parents: Array<{ __typename?: 'NifOrderParent', id: string, position: number, givenNames: string, surname: string, documentNumber: string, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }> }>, address?: { __typename?: 'NifOrderAddress', id: string, lineOne: string, lineTwo?: string | null, city: string, region?: string | null, postalCode: string, country: string } | null, proofOfAddress?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, nifDocumentFile?: { __typename?: 'File', id: string } | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }>, proofOfIdentityDocumentType?: { __typename?: 'ReviewableDocumentType', id: string, key: string } | null } } };

export type NifOrderIntakeDocumentFragment = { __typename?: 'NifOrderIntakeDocument', id: string, titleTranslated: string, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, titleTranslated?: string | null, descriptionTranslated?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } };

export type NifOrderWithReviewableDocumentsFragment = { __typename?: 'NifOrder', id: string, givenNames: string, surname: string, birthDate: string, birthCountry: string, documentType: VerifiableDocumentType, documentNumber: string, documentIssuingCountry: string, documentExpirationDate: string, isPortugueseCitizen?: boolean | null, proofOfAddressId?: string | null, submitedAt?: string | null, status: NifOrderStatus, paidAt?: string | null, gender?: Gender | null, maritalStatus?: MaritalStatus | null, proofOfIdentityDocumentTypeId?: string | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, titleTranslated: string, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, titleTranslated?: string | null, descriptionTranslated?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }>, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, birthCertificate?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, parents: Array<{ __typename?: 'NifOrderParent', id: string, position: number, givenNames: string, surname: string, documentNumber: string, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }> }>, address?: { __typename?: 'NifOrderAddress', id: string, lineOne: string, lineTwo?: string | null, city: string, region?: string | null, postalCode: string, country: string } | null, proofOfAddress?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, nifDocumentFile?: { __typename?: 'File', id: string } | null, proofOfIdentityDocumentType?: { __typename?: 'ReviewableDocumentType', id: string, key: string } | null };

export type GetNifOrderWithReviewableDocumentsQueryVariables = Exact<{
  id: Scalars['Uuid']['input'];
  locale: Scalars['String']['input'];
}>;


export type GetNifOrderWithReviewableDocumentsQuery = { __typename?: 'Query', nifOrder: { __typename?: 'NifOrder', id: string, givenNames: string, surname: string, birthDate: string, birthCountry: string, documentType: VerifiableDocumentType, documentNumber: string, documentIssuingCountry: string, documentExpirationDate: string, isPortugueseCitizen?: boolean | null, proofOfAddressId?: string | null, submitedAt?: string | null, status: NifOrderStatus, paidAt?: string | null, gender?: Gender | null, maritalStatus?: MaritalStatus | null, proofOfIdentityDocumentTypeId?: string | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, titleTranslated: string, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, titleTranslated?: string | null, descriptionTranslated?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }>, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, birthCertificate?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, parents: Array<{ __typename?: 'NifOrderParent', id: string, position: number, givenNames: string, surname: string, documentNumber: string, proofOfIdentity?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, intakeDocuments: Array<{ __typename?: 'NifOrderIntakeDocument', id: string, documentCategoryId: string, parentId?: string | null, reviewableDocument: { __typename?: 'ReviewableDocument', id: string, categoryId: string, documentTypeId?: string | null, currentVersion?: { __typename?: 'ReviewableDocumentVersion', id: string, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null, documentType: { __typename?: 'ReviewableDocumentType', id: string, name: string, key: string }, reviews: Array<{ __typename?: 'ReviewableDocumentReview', id: string, isApproved: boolean, reviewerType: ReviewableDocumentReviewerType }> } | null } }> }>, address?: { __typename?: 'NifOrderAddress', id: string, lineOne: string, lineTwo?: string | null, city: string, region?: string | null, postalCode: string, country: string } | null, proofOfAddress?: { __typename?: 'VerifiableDocument', id: string, type: VerifiableDocumentType, status: VerifiableDocumentStatus, fileOne: { __typename?: 'File', id: string, name: string }, fileTwo?: { __typename?: 'File', id: string, name: string } | null } | null, nifDocumentFile?: { __typename?: 'File', id: string } | null, proofOfIdentityDocumentType?: { __typename?: 'ReviewableDocumentType', id: string, key: string } | null } };

export type NifOrderUploadPoaDataFragment = { __typename: 'NifOrder', id: string, givenNames: string, surname: string, status: NifOrderStatus, nifNumber?: string | null, hasPasswordRequest: boolean, hasCompletedPasswordRequest: boolean, createdAt: string, poaTemplateFile?: { __typename?: 'File', id: string } | null, nifDocumentFile?: { __typename?: 'File', id: string } | null };

export type GetNifOrderWithUploadPoaDataQueryVariables = Exact<{
  id: Scalars['Uuid']['input'];
}>;


export type GetNifOrderWithUploadPoaDataQuery = { __typename?: 'Query', nifOrder: { __typename: 'NifOrder', id: string, givenNames: string, surname: string, status: NifOrderStatus, nifNumber?: string | null, hasPasswordRequest: boolean, hasCompletedPasswordRequest: boolean, createdAt: string, poaTemplateFile?: { __typename?: 'File', id: string } | null, nifDocumentFile?: { __typename?: 'File', id: string } | null } };

export type UploadNifOrderPoaMutationVariables = Exact<{
  input: UploadNifOrderPoaInput;
}>;


export type UploadNifOrderPoaMutation = { __typename?: 'Mutation', uploadNifOrderPoa: { __typename?: 'UploadNifOrderPoaPayload', nifOrder: { __typename: 'NifOrder', id: string, givenNames: string, surname: string, status: NifOrderStatus, nifNumber?: string | null, hasPasswordRequest: boolean, hasCompletedPasswordRequest: boolean, createdAt: string, nifDocumentFile?: { __typename?: 'File', id: string } | null } } };

export type CreateOrderVoucherCheckoutUrlMutationVariables = Exact<{
  input: CreateOrderVoucherCheckoutUrlInput;
}>;


export type CreateOrderVoucherCheckoutUrlMutation = { __typename?: 'Mutation', createOrderVoucherCheckoutUrl: { __typename?: 'CreateOrderVoucherCheckoutUrlPayload', url: string } };

export const CurrentUserFragmentDoc = gql`
    fragment CurrentUser on User {
  id
  email
  name
  isRegistered
  isSubscribedToMarketing
  locale
  isEmailSuppressed
}
    `;
export const FiscalRepSubscriptionRowFragmentDoc = gql`
    fragment FiscalRepSubscriptionRow on FiscalRepSubscription {
  id
  givenNames
  surname
  isActive
  renewalDateTime
  createdAt
  nifNumber
  isUnpaid
  cancellationRequests {
    id
    isComplete
    cancellationDocumentType
    proofOfCancellationDocument {
      id
      status
    }
    type
    contractUrl
    signedContractFileId
    createdAt
    completedSuccessfullyAt
  }
  cancelledAt
  renewalAmountCurrency
  renewalAmountCents
  renewalCreditCardBrand
  renewalCreditCardLastFour
  renewalPaymentType
  stripeSubscriptionId
}
    `;
export const OrderVoucherFragmentDoc = gql`
    fragment OrderVoucher on OrderVoucher {
  id
  type
  quantity
}
    `;
export const FiscalRepDocumentFragmentDoc = gql`
    fragment FiscalRepDocument on FiscalRepDocument {
  id
  fileId
  createdAt
  subscription {
    id
    givenNames
    surname
  }
  type
  portalPassword
}
    `;
export const FileInputFragmentDoc = gql`
    fragment FileInput on File {
  id
  name
}
    `;
export const NifOrderDocumentFragmentDoc = gql`
    fragment NifOrderDocument on NifOrder {
  id
  nifDocumentFileId
  givenNames
  surname
  nifNumber
  nifDocumentFile {
    ...FileInput
  }
  completedAt
}
    ${FileInputFragmentDoc}`;
export const ReviewableDocumentTypeFragmentDoc = gql`
    fragment ReviewableDocumentType on ReviewableDocumentType {
  id
  name
  key
  hasTwoFiles
}
    `;
export const VerifiableDocumentFragmentDoc = gql`
    fragment VerifiableDocument on VerifiableDocument {
  id
  type
  status
  fileOne {
    ...FileInput
  }
  fileTwo {
    ...FileInput
  }
}
    ${FileInputFragmentDoc}`;
export const ReviewableDocumentFragmentDoc = gql`
    fragment ReviewableDocument on ReviewableDocument {
  id
  categoryId
  documentTypeId
  currentVersion {
    id
    fileOne {
      ...FileInput
    }
    fileTwo {
      ...FileInput
    }
    documentType {
      id
      name
      key
    }
    reviews {
      id
      isApproved
      reviewerType
    }
  }
}
    ${FileInputFragmentDoc}`;
export const NifOrderFragmentDoc = gql`
    fragment NifOrder on NifOrder {
  id
  givenNames
  surname
  birthDate
  birthCountry
  documentType
  documentNumber
  documentIssuingCountry
  documentExpirationDate
  proofOfIdentity {
    ...VerifiableDocument
  }
  birthCertificate {
    ...VerifiableDocument
  }
  isPortugueseCitizen
  parents {
    id
    position
    givenNames
    surname
    documentNumber
    proofOfIdentity {
      ...VerifiableDocument
    }
    intakeDocuments {
      id
      documentCategoryId
      parentId
      reviewableDocument {
        ...ReviewableDocument
      }
    }
  }
  address {
    id
    lineOne
    lineTwo
    city
    region
    postalCode
    country
  }
  proofOfAddress {
    ...VerifiableDocument
  }
  proofOfAddressId
  submitedAt
  status
  nifDocumentFile {
    id
  }
  paidAt
  gender
  maritalStatus
  intakeDocuments {
    id
    documentCategoryId
    parentId
    reviewableDocument {
      ...ReviewableDocument
    }
  }
  proofOfIdentityDocumentTypeId
  proofOfIdentityDocumentType {
    id
    key
  }
}
    ${VerifiableDocumentFragmentDoc}
${ReviewableDocumentFragmentDoc}`;
export const NifOrderWithAdditionalDocumentsFragmentDoc = gql`
    fragment NifOrderWithAdditionalDocuments on NifOrder {
  ...NifOrder
  additionalDocuments {
    id
    translatedTitle(locale: $locale)
    translatedDescription(locale: $locale)
    createdAt
    verifiableDocument {
      ...VerifiableDocument
    }
  }
}
    ${NifOrderFragmentDoc}
${VerifiableDocumentFragmentDoc}`;
export const ReviewableDocumentWithTitleDescriptionFragmentDoc = gql`
    fragment ReviewableDocumentWithTitleDescription on ReviewableDocument {
  id
  categoryId
  documentTypeId
  titleTranslated(locale: $locale)
  descriptionTranslated(locale: $locale)
  currentVersion {
    id
    fileOne {
      ...FileInput
    }
    fileTwo {
      ...FileInput
    }
    documentType {
      id
      name
      key
    }
    reviews {
      id
      isApproved
      reviewerType
    }
  }
}
    ${FileInputFragmentDoc}`;
export const NifOrderIntakeDocumentFragmentDoc = gql`
    fragment NifOrderIntakeDocument on NifOrderIntakeDocument {
  id
  titleTranslated(locale: $locale)
  reviewableDocument {
    ...ReviewableDocumentWithTitleDescription
  }
}
    ${ReviewableDocumentWithTitleDescriptionFragmentDoc}`;
export const NifOrderWithReviewableDocumentsFragmentDoc = gql`
    fragment NifOrderWithReviewableDocuments on NifOrder {
  id
  ...NifOrder
  intakeDocuments {
    ...NifOrderIntakeDocument
  }
}
    ${NifOrderFragmentDoc}
${NifOrderIntakeDocumentFragmentDoc}`;
export const NifOrderRowFragmentDoc = gql`
    fragment NifOrderRow on NifOrder {
  __typename
  id
  givenNames
  surname
  status
  nifDocumentFile {
    id
  }
  nifNumber
  hasPasswordRequest
  hasCompletedPasswordRequest
  createdAt
}
    `;
export const NifOrderUploadPoaDataFragmentDoc = gql`
    fragment NifOrderUploadPoaData on NifOrder {
  id
  ...NifOrderRow
  poaTemplateFile {
    id
  }
}
    ${NifOrderRowFragmentDoc}`;
export const CreateUploadUrlDocument = gql`
    mutation CreateUploadUrl($input: CreatePresignedUploadUrlInput!) {
  createPresignedUploadUrl(input: $input) {
    url
    fields {
      name
      value
    }
    method
    file {
      ...FileInput
    }
  }
}
    ${FileInputFragmentDoc}`;
export type CreateUploadUrlMutationFn = Apollo.MutationFunction<CreateUploadUrlMutation, CreateUploadUrlMutationVariables>;

/**
 * __useCreateUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUploadUrlMutation, { data, loading, error }] = useCreateUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateUploadUrlMutation, CreateUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUploadUrlMutation, CreateUploadUrlMutationVariables>(CreateUploadUrlDocument, options);
      }
export type CreateUploadUrlMutationHookResult = ReturnType<typeof useCreateUploadUrlMutation>;
export type CreateUploadUrlMutationResult = Apollo.MutationResult<CreateUploadUrlMutation>;
export type CreateUploadUrlMutationOptions = Apollo.BaseMutationOptions<CreateUploadUrlMutation, CreateUploadUrlMutationVariables>;
export const GetPresignedDownloadUrlDocument = gql`
    mutation GetPresignedDownloadUrl($input: CreatePresignedDownloadUrlInput!) {
  createPresignedDownloadUrl(input: $input) {
    url
  }
}
    `;
export type GetPresignedDownloadUrlMutationFn = Apollo.MutationFunction<GetPresignedDownloadUrlMutation, GetPresignedDownloadUrlMutationVariables>;

/**
 * __useGetPresignedDownloadUrlMutation__
 *
 * To run a mutation, you first call `useGetPresignedDownloadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPresignedDownloadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPresignedDownloadUrlMutation, { data, loading, error }] = useGetPresignedDownloadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPresignedDownloadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetPresignedDownloadUrlMutation, GetPresignedDownloadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetPresignedDownloadUrlMutation, GetPresignedDownloadUrlMutationVariables>(GetPresignedDownloadUrlDocument, options);
      }
export type GetPresignedDownloadUrlMutationHookResult = ReturnType<typeof useGetPresignedDownloadUrlMutation>;
export type GetPresignedDownloadUrlMutationResult = Apollo.MutationResult<GetPresignedDownloadUrlMutation>;
export type GetPresignedDownloadUrlMutationOptions = Apollo.BaseMutationOptions<GetPresignedDownloadUrlMutation, GetPresignedDownloadUrlMutationVariables>;
export const GetUserByIdDocument = gql`
    query getUserById($id: Uuid!) {
  user(id: $id) {
    ...CurrentUser
  }
}
    ${CurrentUserFragmentDoc}`;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables> & ({ variables: GetUserByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
// @ts-ignore
export function useGetUserByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export function useGetUserByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserByIdQuery | undefined, GetUserByIdQueryVariables>;
export function useGetUserByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdSuspenseQueryHookResult = ReturnType<typeof useGetUserByIdSuspenseQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const UpdateUserDetailsDocument = gql`
    mutation UpdateUserDetails($input: UpdateUserDetailsInput!) {
  updateUserDetails(input: $input) {
    user {
      ...CurrentUser
    }
  }
}
    ${CurrentUserFragmentDoc}`;
export type UpdateUserDetailsMutationFn = Apollo.MutationFunction<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>;

/**
 * __useUpdateUserDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateUserDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDetailsMutation, { data, loading, error }] = useUpdateUserDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>(UpdateUserDetailsDocument, options);
      }
export type UpdateUserDetailsMutationHookResult = ReturnType<typeof useUpdateUserDetailsMutation>;
export type UpdateUserDetailsMutationResult = Apollo.MutationResult<UpdateUserDetailsMutation>;
export type UpdateUserDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>;
export const RegisterUserAsCustomerDocument = gql`
    mutation RegisterUserAsCustomer($input: RegisterUserAsCustomerInput!) {
  registerUserAsCustomer(input: $input) {
    user {
      ...CurrentUser
    }
  }
}
    ${CurrentUserFragmentDoc}`;
export type RegisterUserAsCustomerMutationFn = Apollo.MutationFunction<RegisterUserAsCustomerMutation, RegisterUserAsCustomerMutationVariables>;

/**
 * __useRegisterUserAsCustomerMutation__
 *
 * To run a mutation, you first call `useRegisterUserAsCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserAsCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserAsCustomerMutation, { data, loading, error }] = useRegisterUserAsCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserAsCustomerMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserAsCustomerMutation, RegisterUserAsCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserAsCustomerMutation, RegisterUserAsCustomerMutationVariables>(RegisterUserAsCustomerDocument, options);
      }
export type RegisterUserAsCustomerMutationHookResult = ReturnType<typeof useRegisterUserAsCustomerMutation>;
export type RegisterUserAsCustomerMutationResult = Apollo.MutationResult<RegisterUserAsCustomerMutation>;
export type RegisterUserAsCustomerMutationOptions = Apollo.BaseMutationOptions<RegisterUserAsCustomerMutation, RegisterUserAsCustomerMutationVariables>;
export const ResendEmailVerificationDocument = gql`
    mutation ResendEmailVerification {
  resendEmailVerification {
    success
  }
}
    `;
export type ResendEmailVerificationMutationFn = Apollo.MutationFunction<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>;

/**
 * __useResendEmailVerificationMutation__
 *
 * To run a mutation, you first call `useResendEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailVerificationMutation, { data, loading, error }] = useResendEmailVerificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useResendEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>(ResendEmailVerificationDocument, options);
      }
export type ResendEmailVerificationMutationHookResult = ReturnType<typeof useResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationResult = Apollo.MutationResult<ResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationOptions = Apollo.BaseMutationOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>;
export const CreateUpdateFiscalRepPaymentDetailsCheckoutUrlDocument = gql`
    mutation CreateUpdateFiscalRepPaymentDetailsCheckoutUrl($input: CreateUpdateFiscalRepPaymentDetailsCheckoutUrlInput!) {
  createUpdateFiscalRepPaymentDetailsCheckoutUrl(input: $input) {
    checkoutUrl
  }
}
    `;
export type CreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutationFn = Apollo.MutationFunction<CreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutation, CreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutationVariables>;

/**
 * __useCreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutation__
 *
 * To run a mutation, you first call `useCreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateFiscalRepPaymentDetailsCheckoutUrlMutation, { data, loading, error }] = useCreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutation, CreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutation, CreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutationVariables>(CreateUpdateFiscalRepPaymentDetailsCheckoutUrlDocument, options);
      }
export type CreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutationHookResult = ReturnType<typeof useCreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutation>;
export type CreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutationResult = Apollo.MutationResult<CreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutation>;
export type CreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutationOptions = Apollo.BaseMutationOptions<CreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutation, CreateUpdateFiscalRepPaymentDetailsCheckoutUrlMutationVariables>;
export const GetOrdersDocument = gql`
    query GetOrders($userId: Uuid!) {
  nifOrders(where: {userId: $userId}) {
    ...NifOrderRow
  }
  fiscalRepSubscriptions(where: {userId: $userId}) {
    ...FiscalRepSubscriptionRow
  }
  user(id: $userId) {
    id
    orderVouchers {
      ...OrderVoucher
    }
  }
}
    ${NifOrderRowFragmentDoc}
${FiscalRepSubscriptionRowFragmentDoc}
${OrderVoucherFragmentDoc}`;

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables> & ({ variables: GetOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
      }
export function useGetOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
// @ts-ignore
export function useGetOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersQuery, GetOrdersQueryVariables>;
export function useGetOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersQuery | undefined, GetOrdersQueryVariables>;
export function useGetOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
export type GetOrdersQueryHookResult = ReturnType<typeof useGetOrdersQuery>;
export type GetOrdersLazyQueryHookResult = ReturnType<typeof useGetOrdersLazyQuery>;
export type GetOrdersSuspenseQueryHookResult = ReturnType<typeof useGetOrdersSuspenseQuery>;
export type GetOrdersQueryResult = Apollo.QueryResult<GetOrdersQuery, GetOrdersQueryVariables>;
export const DeleteNifOrderDocument = gql`
    mutation DeleteNifOrder($id: Uuid!) {
  deleteNifOrder(input: {id: $id}) {
    nifOrder {
      id
      user {
        id
        orderVouchers {
          ...OrderVoucher
        }
      }
    }
  }
}
    ${OrderVoucherFragmentDoc}`;
export type DeleteNifOrderMutationFn = Apollo.MutationFunction<DeleteNifOrderMutation, DeleteNifOrderMutationVariables>;

/**
 * __useDeleteNifOrderMutation__
 *
 * To run a mutation, you first call `useDeleteNifOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNifOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNifOrderMutation, { data, loading, error }] = useDeleteNifOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNifOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNifOrderMutation, DeleteNifOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNifOrderMutation, DeleteNifOrderMutationVariables>(DeleteNifOrderDocument, options);
      }
export type DeleteNifOrderMutationHookResult = ReturnType<typeof useDeleteNifOrderMutation>;
export type DeleteNifOrderMutationResult = Apollo.MutationResult<DeleteNifOrderMutation>;
export type DeleteNifOrderMutationOptions = Apollo.BaseMutationOptions<DeleteNifOrderMutation, DeleteNifOrderMutationVariables>;
export const CheckFiscalRepPaymentStatusDocument = gql`
    mutation CheckFiscalRepPaymentStatus($input: CheckFiscalRepPaymentStatusInput!) {
  checkFiscalRepPaymentStatus(input: $input) {
    fiscalRepSubscription {
      ...FiscalRepSubscriptionRow
    }
  }
}
    ${FiscalRepSubscriptionRowFragmentDoc}`;
export type CheckFiscalRepPaymentStatusMutationFn = Apollo.MutationFunction<CheckFiscalRepPaymentStatusMutation, CheckFiscalRepPaymentStatusMutationVariables>;

/**
 * __useCheckFiscalRepPaymentStatusMutation__
 *
 * To run a mutation, you first call `useCheckFiscalRepPaymentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckFiscalRepPaymentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkFiscalRepPaymentStatusMutation, { data, loading, error }] = useCheckFiscalRepPaymentStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckFiscalRepPaymentStatusMutation(baseOptions?: Apollo.MutationHookOptions<CheckFiscalRepPaymentStatusMutation, CheckFiscalRepPaymentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckFiscalRepPaymentStatusMutation, CheckFiscalRepPaymentStatusMutationVariables>(CheckFiscalRepPaymentStatusDocument, options);
      }
export type CheckFiscalRepPaymentStatusMutationHookResult = ReturnType<typeof useCheckFiscalRepPaymentStatusMutation>;
export type CheckFiscalRepPaymentStatusMutationResult = Apollo.MutationResult<CheckFiscalRepPaymentStatusMutation>;
export type CheckFiscalRepPaymentStatusMutationOptions = Apollo.BaseMutationOptions<CheckFiscalRepPaymentStatusMutation, CheckFiscalRepPaymentStatusMutationVariables>;
export const CheckOrderVoucherPaymentStatusDocument = gql`
    mutation CheckOrderVoucherPaymentStatus($input: CheckOrderVoucherPaymentStatusInput!) {
  checkOrderVoucherPaymentStatus(input: $input) {
    user {
      id
      orderVouchers {
        ...OrderVoucher
      }
    }
  }
}
    ${OrderVoucherFragmentDoc}`;
export type CheckOrderVoucherPaymentStatusMutationFn = Apollo.MutationFunction<CheckOrderVoucherPaymentStatusMutation, CheckOrderVoucherPaymentStatusMutationVariables>;

/**
 * __useCheckOrderVoucherPaymentStatusMutation__
 *
 * To run a mutation, you first call `useCheckOrderVoucherPaymentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckOrderVoucherPaymentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkOrderVoucherPaymentStatusMutation, { data, loading, error }] = useCheckOrderVoucherPaymentStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckOrderVoucherPaymentStatusMutation(baseOptions?: Apollo.MutationHookOptions<CheckOrderVoucherPaymentStatusMutation, CheckOrderVoucherPaymentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckOrderVoucherPaymentStatusMutation, CheckOrderVoucherPaymentStatusMutationVariables>(CheckOrderVoucherPaymentStatusDocument, options);
      }
export type CheckOrderVoucherPaymentStatusMutationHookResult = ReturnType<typeof useCheckOrderVoucherPaymentStatusMutation>;
export type CheckOrderVoucherPaymentStatusMutationResult = Apollo.MutationResult<CheckOrderVoucherPaymentStatusMutation>;
export type CheckOrderVoucherPaymentStatusMutationOptions = Apollo.BaseMutationOptions<CheckOrderVoucherPaymentStatusMutation, CheckOrderVoucherPaymentStatusMutationVariables>;
export const CheckEsignatureContractStatusDocument = gql`
    mutation CheckEsignatureContractStatus($input: CheckEsignatureContractStatusInput!) {
  checkEsignatureContractStatus(input: $input) {
    didUpdate
  }
}
    `;
export type CheckEsignatureContractStatusMutationFn = Apollo.MutationFunction<CheckEsignatureContractStatusMutation, CheckEsignatureContractStatusMutationVariables>;

/**
 * __useCheckEsignatureContractStatusMutation__
 *
 * To run a mutation, you first call `useCheckEsignatureContractStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckEsignatureContractStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkEsignatureContractStatusMutation, { data, loading, error }] = useCheckEsignatureContractStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckEsignatureContractStatusMutation(baseOptions?: Apollo.MutationHookOptions<CheckEsignatureContractStatusMutation, CheckEsignatureContractStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckEsignatureContractStatusMutation, CheckEsignatureContractStatusMutationVariables>(CheckEsignatureContractStatusDocument, options);
      }
export type CheckEsignatureContractStatusMutationHookResult = ReturnType<typeof useCheckEsignatureContractStatusMutation>;
export type CheckEsignatureContractStatusMutationResult = Apollo.MutationResult<CheckEsignatureContractStatusMutation>;
export type CheckEsignatureContractStatusMutationOptions = Apollo.BaseMutationOptions<CheckEsignatureContractStatusMutation, CheckEsignatureContractStatusMutationVariables>;
export const GetDocumentsDocument = gql`
    query GetDocuments($userId: Uuid!) {
  fiscalRepDocuments(userId: $userId) {
    ...FiscalRepDocument
  }
  nifOrders(where: {userId: $userId}) {
    ...NifOrderDocument
  }
}
    ${FiscalRepDocumentFragmentDoc}
${NifOrderDocumentFragmentDoc}`;

/**
 * __useGetDocumentsQuery__
 *
 * To run a query within a React component, call `useGetDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentsQuery, GetDocumentsQueryVariables> & ({ variables: GetDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(GetDocumentsDocument, options);
      }
export function useGetDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentsQuery, GetDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(GetDocumentsDocument, options);
        }
// @ts-ignore
export function useGetDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentsQuery, GetDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentsQuery, GetDocumentsQueryVariables>;
export function useGetDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentsQuery, GetDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentsQuery | undefined, GetDocumentsQueryVariables>;
export function useGetDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentsQuery, GetDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(GetDocumentsDocument, options);
        }
export type GetDocumentsQueryHookResult = ReturnType<typeof useGetDocumentsQuery>;
export type GetDocumentsLazyQueryHookResult = ReturnType<typeof useGetDocumentsLazyQuery>;
export type GetDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentsSuspenseQuery>;
export type GetDocumentsQueryResult = Apollo.QueryResult<GetDocumentsQuery, GetDocumentsQueryVariables>;
export const ReuploadReviewableDocumentDocument = gql`
    mutation ReuploadReviewableDocument($input: ReuploadReviewableDocumentInput!, $locale: String!) {
  reuploadReviewableDocument(input: $input) {
    reviewableDocument {
      ...ReviewableDocumentWithTitleDescription
    }
  }
}
    ${ReviewableDocumentWithTitleDescriptionFragmentDoc}`;
export type ReuploadReviewableDocumentMutationFn = Apollo.MutationFunction<ReuploadReviewableDocumentMutation, ReuploadReviewableDocumentMutationVariables>;

/**
 * __useReuploadReviewableDocumentMutation__
 *
 * To run a mutation, you first call `useReuploadReviewableDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReuploadReviewableDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reuploadReviewableDocumentMutation, { data, loading, error }] = useReuploadReviewableDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useReuploadReviewableDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ReuploadReviewableDocumentMutation, ReuploadReviewableDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReuploadReviewableDocumentMutation, ReuploadReviewableDocumentMutationVariables>(ReuploadReviewableDocumentDocument, options);
      }
export type ReuploadReviewableDocumentMutationHookResult = ReturnType<typeof useReuploadReviewableDocumentMutation>;
export type ReuploadReviewableDocumentMutationResult = Apollo.MutationResult<ReuploadReviewableDocumentMutation>;
export type ReuploadReviewableDocumentMutationOptions = Apollo.BaseMutationOptions<ReuploadReviewableDocumentMutation, ReuploadReviewableDocumentMutationVariables>;
export const FiscalRepresentationByIdDocument = gql`
    query FiscalRepresentationById($id: Uuid!) {
  fiscalRepSubscription(id: $id) {
    ...FiscalRepSubscriptionRow
  }
}
    ${FiscalRepSubscriptionRowFragmentDoc}`;

/**
 * __useFiscalRepresentationByIdQuery__
 *
 * To run a query within a React component, call `useFiscalRepresentationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiscalRepresentationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiscalRepresentationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFiscalRepresentationByIdQuery(baseOptions: Apollo.QueryHookOptions<FiscalRepresentationByIdQuery, FiscalRepresentationByIdQueryVariables> & ({ variables: FiscalRepresentationByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FiscalRepresentationByIdQuery, FiscalRepresentationByIdQueryVariables>(FiscalRepresentationByIdDocument, options);
      }
export function useFiscalRepresentationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FiscalRepresentationByIdQuery, FiscalRepresentationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FiscalRepresentationByIdQuery, FiscalRepresentationByIdQueryVariables>(FiscalRepresentationByIdDocument, options);
        }
// @ts-ignore
export function useFiscalRepresentationByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FiscalRepresentationByIdQuery, FiscalRepresentationByIdQueryVariables>): Apollo.UseSuspenseQueryResult<FiscalRepresentationByIdQuery, FiscalRepresentationByIdQueryVariables>;
export function useFiscalRepresentationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FiscalRepresentationByIdQuery, FiscalRepresentationByIdQueryVariables>): Apollo.UseSuspenseQueryResult<FiscalRepresentationByIdQuery | undefined, FiscalRepresentationByIdQueryVariables>;
export function useFiscalRepresentationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FiscalRepresentationByIdQuery, FiscalRepresentationByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FiscalRepresentationByIdQuery, FiscalRepresentationByIdQueryVariables>(FiscalRepresentationByIdDocument, options);
        }
export type FiscalRepresentationByIdQueryHookResult = ReturnType<typeof useFiscalRepresentationByIdQuery>;
export type FiscalRepresentationByIdLazyQueryHookResult = ReturnType<typeof useFiscalRepresentationByIdLazyQuery>;
export type FiscalRepresentationByIdSuspenseQueryHookResult = ReturnType<typeof useFiscalRepresentationByIdSuspenseQuery>;
export type FiscalRepresentationByIdQueryResult = Apollo.QueryResult<FiscalRepresentationByIdQuery, FiscalRepresentationByIdQueryVariables>;
export const RequestFiscalRepCancellationDocument = gql`
    mutation RequestFiscalRepCancellation($input: RequestFiscalRepCancellationInput!) {
  requestFiscalRepCancellation(input: $input) {
    subscription {
      ...FiscalRepSubscriptionRow
    }
  }
}
    ${FiscalRepSubscriptionRowFragmentDoc}`;
export type RequestFiscalRepCancellationMutationFn = Apollo.MutationFunction<RequestFiscalRepCancellationMutation, RequestFiscalRepCancellationMutationVariables>;

/**
 * __useRequestFiscalRepCancellationMutation__
 *
 * To run a mutation, you first call `useRequestFiscalRepCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestFiscalRepCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestFiscalRepCancellationMutation, { data, loading, error }] = useRequestFiscalRepCancellationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestFiscalRepCancellationMutation(baseOptions?: Apollo.MutationHookOptions<RequestFiscalRepCancellationMutation, RequestFiscalRepCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestFiscalRepCancellationMutation, RequestFiscalRepCancellationMutationVariables>(RequestFiscalRepCancellationDocument, options);
      }
export type RequestFiscalRepCancellationMutationHookResult = ReturnType<typeof useRequestFiscalRepCancellationMutation>;
export type RequestFiscalRepCancellationMutationResult = Apollo.MutationResult<RequestFiscalRepCancellationMutation>;
export type RequestFiscalRepCancellationMutationOptions = Apollo.BaseMutationOptions<RequestFiscalRepCancellationMutation, RequestFiscalRepCancellationMutationVariables>;
export const GetNifOrderRowDocument = gql`
    query GetNifOrderRow($id: Uuid!) {
  nifOrder(id: $id) {
    ...NifOrderRow
  }
}
    ${NifOrderRowFragmentDoc}`;

/**
 * __useGetNifOrderRowQuery__
 *
 * To run a query within a React component, call `useGetNifOrderRowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNifOrderRowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNifOrderRowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNifOrderRowQuery(baseOptions: Apollo.QueryHookOptions<GetNifOrderRowQuery, GetNifOrderRowQueryVariables> & ({ variables: GetNifOrderRowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNifOrderRowQuery, GetNifOrderRowQueryVariables>(GetNifOrderRowDocument, options);
      }
export function useGetNifOrderRowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNifOrderRowQuery, GetNifOrderRowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNifOrderRowQuery, GetNifOrderRowQueryVariables>(GetNifOrderRowDocument, options);
        }
// @ts-ignore
export function useGetNifOrderRowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNifOrderRowQuery, GetNifOrderRowQueryVariables>): Apollo.UseSuspenseQueryResult<GetNifOrderRowQuery, GetNifOrderRowQueryVariables>;
export function useGetNifOrderRowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNifOrderRowQuery, GetNifOrderRowQueryVariables>): Apollo.UseSuspenseQueryResult<GetNifOrderRowQuery | undefined, GetNifOrderRowQueryVariables>;
export function useGetNifOrderRowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNifOrderRowQuery, GetNifOrderRowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNifOrderRowQuery, GetNifOrderRowQueryVariables>(GetNifOrderRowDocument, options);
        }
export type GetNifOrderRowQueryHookResult = ReturnType<typeof useGetNifOrderRowQuery>;
export type GetNifOrderRowLazyQueryHookResult = ReturnType<typeof useGetNifOrderRowLazyQuery>;
export type GetNifOrderRowSuspenseQueryHookResult = ReturnType<typeof useGetNifOrderRowSuspenseQuery>;
export type GetNifOrderRowQueryResult = Apollo.QueryResult<GetNifOrderRowQuery, GetNifOrderRowQueryVariables>;
export const GetNifOrderFullDocument = gql`
    query GetNifOrderFull($id: Uuid!) {
  nifOrder(id: $id) {
    ...NifOrder
  }
}
    ${NifOrderFragmentDoc}`;

/**
 * __useGetNifOrderFullQuery__
 *
 * To run a query within a React component, call `useGetNifOrderFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNifOrderFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNifOrderFullQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNifOrderFullQuery(baseOptions: Apollo.QueryHookOptions<GetNifOrderFullQuery, GetNifOrderFullQueryVariables> & ({ variables: GetNifOrderFullQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNifOrderFullQuery, GetNifOrderFullQueryVariables>(GetNifOrderFullDocument, options);
      }
export function useGetNifOrderFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNifOrderFullQuery, GetNifOrderFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNifOrderFullQuery, GetNifOrderFullQueryVariables>(GetNifOrderFullDocument, options);
        }
// @ts-ignore
export function useGetNifOrderFullSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNifOrderFullQuery, GetNifOrderFullQueryVariables>): Apollo.UseSuspenseQueryResult<GetNifOrderFullQuery, GetNifOrderFullQueryVariables>;
export function useGetNifOrderFullSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNifOrderFullQuery, GetNifOrderFullQueryVariables>): Apollo.UseSuspenseQueryResult<GetNifOrderFullQuery | undefined, GetNifOrderFullQueryVariables>;
export function useGetNifOrderFullSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNifOrderFullQuery, GetNifOrderFullQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNifOrderFullQuery, GetNifOrderFullQueryVariables>(GetNifOrderFullDocument, options);
        }
export type GetNifOrderFullQueryHookResult = ReturnType<typeof useGetNifOrderFullQuery>;
export type GetNifOrderFullLazyQueryHookResult = ReturnType<typeof useGetNifOrderFullLazyQuery>;
export type GetNifOrderFullSuspenseQueryHookResult = ReturnType<typeof useGetNifOrderFullSuspenseQuery>;
export type GetNifOrderFullQueryResult = Apollo.QueryResult<GetNifOrderFullQuery, GetNifOrderFullQueryVariables>;
export const GetNifOrderWithAdditionalDocumentsDocument = gql`
    query GetNifOrderWithAdditionalDocuments($id: Uuid!, $locale: String!) {
  nifOrder(id: $id) {
    ...NifOrderWithAdditionalDocuments
  }
}
    ${NifOrderWithAdditionalDocumentsFragmentDoc}`;

/**
 * __useGetNifOrderWithAdditionalDocumentsQuery__
 *
 * To run a query within a React component, call `useGetNifOrderWithAdditionalDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNifOrderWithAdditionalDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNifOrderWithAdditionalDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetNifOrderWithAdditionalDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetNifOrderWithAdditionalDocumentsQuery, GetNifOrderWithAdditionalDocumentsQueryVariables> & ({ variables: GetNifOrderWithAdditionalDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNifOrderWithAdditionalDocumentsQuery, GetNifOrderWithAdditionalDocumentsQueryVariables>(GetNifOrderWithAdditionalDocumentsDocument, options);
      }
export function useGetNifOrderWithAdditionalDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNifOrderWithAdditionalDocumentsQuery, GetNifOrderWithAdditionalDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNifOrderWithAdditionalDocumentsQuery, GetNifOrderWithAdditionalDocumentsQueryVariables>(GetNifOrderWithAdditionalDocumentsDocument, options);
        }
// @ts-ignore
export function useGetNifOrderWithAdditionalDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNifOrderWithAdditionalDocumentsQuery, GetNifOrderWithAdditionalDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNifOrderWithAdditionalDocumentsQuery, GetNifOrderWithAdditionalDocumentsQueryVariables>;
export function useGetNifOrderWithAdditionalDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNifOrderWithAdditionalDocumentsQuery, GetNifOrderWithAdditionalDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNifOrderWithAdditionalDocumentsQuery | undefined, GetNifOrderWithAdditionalDocumentsQueryVariables>;
export function useGetNifOrderWithAdditionalDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNifOrderWithAdditionalDocumentsQuery, GetNifOrderWithAdditionalDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNifOrderWithAdditionalDocumentsQuery, GetNifOrderWithAdditionalDocumentsQueryVariables>(GetNifOrderWithAdditionalDocumentsDocument, options);
        }
export type GetNifOrderWithAdditionalDocumentsQueryHookResult = ReturnType<typeof useGetNifOrderWithAdditionalDocumentsQuery>;
export type GetNifOrderWithAdditionalDocumentsLazyQueryHookResult = ReturnType<typeof useGetNifOrderWithAdditionalDocumentsLazyQuery>;
export type GetNifOrderWithAdditionalDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetNifOrderWithAdditionalDocumentsSuspenseQuery>;
export type GetNifOrderWithAdditionalDocumentsQueryResult = Apollo.QueryResult<GetNifOrderWithAdditionalDocumentsQuery, GetNifOrderWithAdditionalDocumentsQueryVariables>;
export const CreateNifOrderDocument = gql`
    mutation CreateNifOrder($input: CreateNifOrderInput!) {
  createNifOrder(input: $input) {
    nifOrder {
      ...NifOrder
      user {
        id
        orderVouchers {
          ...OrderVoucher
        }
      }
    }
  }
}
    ${NifOrderFragmentDoc}
${OrderVoucherFragmentDoc}`;
export type CreateNifOrderMutationFn = Apollo.MutationFunction<CreateNifOrderMutation, CreateNifOrderMutationVariables>;

/**
 * __useCreateNifOrderMutation__
 *
 * To run a mutation, you first call `useCreateNifOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNifOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNifOrderMutation, { data, loading, error }] = useCreateNifOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNifOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateNifOrderMutation, CreateNifOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNifOrderMutation, CreateNifOrderMutationVariables>(CreateNifOrderDocument, options);
      }
export type CreateNifOrderMutationHookResult = ReturnType<typeof useCreateNifOrderMutation>;
export type CreateNifOrderMutationResult = Apollo.MutationResult<CreateNifOrderMutation>;
export type CreateNifOrderMutationOptions = Apollo.BaseMutationOptions<CreateNifOrderMutation, CreateNifOrderMutationVariables>;
export const UpdateNifOrderDocument = gql`
    mutation UpdateNifOrder($input: UpdateNifOrderInput!) {
  updateNifOrder(input: $input) {
    nifOrder {
      ...NifOrder
    }
  }
}
    ${NifOrderFragmentDoc}`;
export type UpdateNifOrderMutationFn = Apollo.MutationFunction<UpdateNifOrderMutation, UpdateNifOrderMutationVariables>;

/**
 * __useUpdateNifOrderMutation__
 *
 * To run a mutation, you first call `useUpdateNifOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNifOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNifOrderMutation, { data, loading, error }] = useUpdateNifOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNifOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNifOrderMutation, UpdateNifOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNifOrderMutation, UpdateNifOrderMutationVariables>(UpdateNifOrderDocument, options);
      }
export type UpdateNifOrderMutationHookResult = ReturnType<typeof useUpdateNifOrderMutation>;
export type UpdateNifOrderMutationResult = Apollo.MutationResult<UpdateNifOrderMutation>;
export type UpdateNifOrderMutationOptions = Apollo.BaseMutationOptions<UpdateNifOrderMutation, UpdateNifOrderMutationVariables>;
export const SubmitNifOrderIntakeDocument = gql`
    mutation SubmitNifOrderIntake($input: SubmitNifOrderIntakeInput!) {
  submitNifOrderIntake(input: $input) {
    nifOrder {
      ...NifOrder
    }
  }
}
    ${NifOrderFragmentDoc}`;
export type SubmitNifOrderIntakeMutationFn = Apollo.MutationFunction<SubmitNifOrderIntakeMutation, SubmitNifOrderIntakeMutationVariables>;

/**
 * __useSubmitNifOrderIntakeMutation__
 *
 * To run a mutation, you first call `useSubmitNifOrderIntakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitNifOrderIntakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitNifOrderIntakeMutation, { data, loading, error }] = useSubmitNifOrderIntakeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitNifOrderIntakeMutation(baseOptions?: Apollo.MutationHookOptions<SubmitNifOrderIntakeMutation, SubmitNifOrderIntakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitNifOrderIntakeMutation, SubmitNifOrderIntakeMutationVariables>(SubmitNifOrderIntakeDocument, options);
      }
export type SubmitNifOrderIntakeMutationHookResult = ReturnType<typeof useSubmitNifOrderIntakeMutation>;
export type SubmitNifOrderIntakeMutationResult = Apollo.MutationResult<SubmitNifOrderIntakeMutation>;
export type SubmitNifOrderIntakeMutationOptions = Apollo.BaseMutationOptions<SubmitNifOrderIntakeMutation, SubmitNifOrderIntakeMutationVariables>;
export const GetNifOrderWithReviewableDocumentsDocument = gql`
    query GetNifOrderWithReviewableDocuments($id: Uuid!, $locale: String!) {
  nifOrder(id: $id) {
    ...NifOrderWithReviewableDocuments
  }
}
    ${NifOrderWithReviewableDocumentsFragmentDoc}`;

/**
 * __useGetNifOrderWithReviewableDocumentsQuery__
 *
 * To run a query within a React component, call `useGetNifOrderWithReviewableDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNifOrderWithReviewableDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNifOrderWithReviewableDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetNifOrderWithReviewableDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetNifOrderWithReviewableDocumentsQuery, GetNifOrderWithReviewableDocumentsQueryVariables> & ({ variables: GetNifOrderWithReviewableDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNifOrderWithReviewableDocumentsQuery, GetNifOrderWithReviewableDocumentsQueryVariables>(GetNifOrderWithReviewableDocumentsDocument, options);
      }
export function useGetNifOrderWithReviewableDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNifOrderWithReviewableDocumentsQuery, GetNifOrderWithReviewableDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNifOrderWithReviewableDocumentsQuery, GetNifOrderWithReviewableDocumentsQueryVariables>(GetNifOrderWithReviewableDocumentsDocument, options);
        }
// @ts-ignore
export function useGetNifOrderWithReviewableDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNifOrderWithReviewableDocumentsQuery, GetNifOrderWithReviewableDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNifOrderWithReviewableDocumentsQuery, GetNifOrderWithReviewableDocumentsQueryVariables>;
export function useGetNifOrderWithReviewableDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNifOrderWithReviewableDocumentsQuery, GetNifOrderWithReviewableDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNifOrderWithReviewableDocumentsQuery | undefined, GetNifOrderWithReviewableDocumentsQueryVariables>;
export function useGetNifOrderWithReviewableDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNifOrderWithReviewableDocumentsQuery, GetNifOrderWithReviewableDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNifOrderWithReviewableDocumentsQuery, GetNifOrderWithReviewableDocumentsQueryVariables>(GetNifOrderWithReviewableDocumentsDocument, options);
        }
export type GetNifOrderWithReviewableDocumentsQueryHookResult = ReturnType<typeof useGetNifOrderWithReviewableDocumentsQuery>;
export type GetNifOrderWithReviewableDocumentsLazyQueryHookResult = ReturnType<typeof useGetNifOrderWithReviewableDocumentsLazyQuery>;
export type GetNifOrderWithReviewableDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetNifOrderWithReviewableDocumentsSuspenseQuery>;
export type GetNifOrderWithReviewableDocumentsQueryResult = Apollo.QueryResult<GetNifOrderWithReviewableDocumentsQuery, GetNifOrderWithReviewableDocumentsQueryVariables>;
export const GetNifOrderWithUploadPoaDataDocument = gql`
    query GetNifOrderWithUploadPoaData($id: Uuid!) {
  nifOrder(id: $id) {
    ...NifOrderUploadPoaData
  }
}
    ${NifOrderUploadPoaDataFragmentDoc}`;

/**
 * __useGetNifOrderWithUploadPoaDataQuery__
 *
 * To run a query within a React component, call `useGetNifOrderWithUploadPoaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNifOrderWithUploadPoaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNifOrderWithUploadPoaDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNifOrderWithUploadPoaDataQuery(baseOptions: Apollo.QueryHookOptions<GetNifOrderWithUploadPoaDataQuery, GetNifOrderWithUploadPoaDataQueryVariables> & ({ variables: GetNifOrderWithUploadPoaDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNifOrderWithUploadPoaDataQuery, GetNifOrderWithUploadPoaDataQueryVariables>(GetNifOrderWithUploadPoaDataDocument, options);
      }
export function useGetNifOrderWithUploadPoaDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNifOrderWithUploadPoaDataQuery, GetNifOrderWithUploadPoaDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNifOrderWithUploadPoaDataQuery, GetNifOrderWithUploadPoaDataQueryVariables>(GetNifOrderWithUploadPoaDataDocument, options);
        }
// @ts-ignore
export function useGetNifOrderWithUploadPoaDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNifOrderWithUploadPoaDataQuery, GetNifOrderWithUploadPoaDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetNifOrderWithUploadPoaDataQuery, GetNifOrderWithUploadPoaDataQueryVariables>;
export function useGetNifOrderWithUploadPoaDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNifOrderWithUploadPoaDataQuery, GetNifOrderWithUploadPoaDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetNifOrderWithUploadPoaDataQuery | undefined, GetNifOrderWithUploadPoaDataQueryVariables>;
export function useGetNifOrderWithUploadPoaDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNifOrderWithUploadPoaDataQuery, GetNifOrderWithUploadPoaDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNifOrderWithUploadPoaDataQuery, GetNifOrderWithUploadPoaDataQueryVariables>(GetNifOrderWithUploadPoaDataDocument, options);
        }
export type GetNifOrderWithUploadPoaDataQueryHookResult = ReturnType<typeof useGetNifOrderWithUploadPoaDataQuery>;
export type GetNifOrderWithUploadPoaDataLazyQueryHookResult = ReturnType<typeof useGetNifOrderWithUploadPoaDataLazyQuery>;
export type GetNifOrderWithUploadPoaDataSuspenseQueryHookResult = ReturnType<typeof useGetNifOrderWithUploadPoaDataSuspenseQuery>;
export type GetNifOrderWithUploadPoaDataQueryResult = Apollo.QueryResult<GetNifOrderWithUploadPoaDataQuery, GetNifOrderWithUploadPoaDataQueryVariables>;
export const UploadNifOrderPoaDocument = gql`
    mutation uploadNifOrderPoa($input: UploadNifOrderPoaInput!) {
  uploadNifOrderPoa(input: $input) {
    nifOrder {
      ...NifOrderRow
    }
  }
}
    ${NifOrderRowFragmentDoc}`;
export type UploadNifOrderPoaMutationFn = Apollo.MutationFunction<UploadNifOrderPoaMutation, UploadNifOrderPoaMutationVariables>;

/**
 * __useUploadNifOrderPoaMutation__
 *
 * To run a mutation, you first call `useUploadNifOrderPoaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadNifOrderPoaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadNifOrderPoaMutation, { data, loading, error }] = useUploadNifOrderPoaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadNifOrderPoaMutation(baseOptions?: Apollo.MutationHookOptions<UploadNifOrderPoaMutation, UploadNifOrderPoaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadNifOrderPoaMutation, UploadNifOrderPoaMutationVariables>(UploadNifOrderPoaDocument, options);
      }
export type UploadNifOrderPoaMutationHookResult = ReturnType<typeof useUploadNifOrderPoaMutation>;
export type UploadNifOrderPoaMutationResult = Apollo.MutationResult<UploadNifOrderPoaMutation>;
export type UploadNifOrderPoaMutationOptions = Apollo.BaseMutationOptions<UploadNifOrderPoaMutation, UploadNifOrderPoaMutationVariables>;
export const CreateOrderVoucherCheckoutUrlDocument = gql`
    mutation CreateOrderVoucherCheckoutUrl($input: CreateOrderVoucherCheckoutUrlInput!) {
  createOrderVoucherCheckoutUrl(input: $input) {
    url
  }
}
    `;
export type CreateOrderVoucherCheckoutUrlMutationFn = Apollo.MutationFunction<CreateOrderVoucherCheckoutUrlMutation, CreateOrderVoucherCheckoutUrlMutationVariables>;

/**
 * __useCreateOrderVoucherCheckoutUrlMutation__
 *
 * To run a mutation, you first call `useCreateOrderVoucherCheckoutUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderVoucherCheckoutUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderVoucherCheckoutUrlMutation, { data, loading, error }] = useCreateOrderVoucherCheckoutUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderVoucherCheckoutUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderVoucherCheckoutUrlMutation, CreateOrderVoucherCheckoutUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderVoucherCheckoutUrlMutation, CreateOrderVoucherCheckoutUrlMutationVariables>(CreateOrderVoucherCheckoutUrlDocument, options);
      }
export type CreateOrderVoucherCheckoutUrlMutationHookResult = ReturnType<typeof useCreateOrderVoucherCheckoutUrlMutation>;
export type CreateOrderVoucherCheckoutUrlMutationResult = Apollo.MutationResult<CreateOrderVoucherCheckoutUrlMutation>;
export type CreateOrderVoucherCheckoutUrlMutationOptions = Apollo.BaseMutationOptions<CreateOrderVoucherCheckoutUrlMutation, CreateOrderVoucherCheckoutUrlMutationVariables>;